import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { resolveNewQuotationCurrencyId } from '@app/core';
import {
  NZ_DRAWER_DATA,
  NzDrawerRef,
  NzDrawerService,
} from 'ng-zorro-antd/drawer';
import {
  Company,
  CrmTag,
  GetParams,
  PostResponse,
  TableColumn,
  ToastConfig,
  EventType,
  EventCreate,
  ConfirmationModalComponent,
  ConfirmationModalConfig,
} from '@app/shared';
import {
  ActivityService,
  Activity,
  BUDGET_STAGES,
  BudgetStage,
  PARENT_ENTITY_TYPE,
  CommunicationService,
  DocumentService,
  DrawerEscapeBlockerService,
  findBudgetStageBlock,
  getSafeImageUrl,
  isExpirationAlert,
  ProjectService,
  ScreenService,
  StServiceService,
} from '@app/core';
import { GlobalValuesService } from '../../../../../core/services/global-values.service';
import { OpportunityService } from '@app/core';
import { AuthService } from '../../../../../core/services/auth.service';
import { FlowEventService } from '../../../../../core/services/flow-event.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NzNotificationService,
  NzNotificationPlacement,
} from 'ng-zorro-antd/notification';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { OpportunitiesUtilsService } from '../../../../opportunities/services/opportunities-utils.service';
import { OpportunityDetailsHelperService } from '../../../../opportunities/services/opportunity-details-helper.service';
import { OpportunityStageService } from '../../../../opportunities/services/opportunity-stage.service';
import { OpportunityPayloadBuilderService } from '../../../../opportunities/services/opportunity-payload-builder.service';
import {
  finalize,
  combineLatest,
  take,
  firstValueFrom,
  forkJoin,
  Observable,
  of,
  from,
  concatMap,
  map,
  catchError,
  filter,
} from 'rxjs';
import {
  buildPastExpirationConfirmation,
  buildIssueCurrencyIgnoredMessage,
  canGenerateBudgetVersion,
  formatBudgetVersionGeneratedMessage,
  getPastBudgetExpiration,
  mapBudgetVersionGenerationError,
  wasIssueCurrencyIgnored,
} from '../../../../opportunities/components/budget-pdf-versions/budget-version-generation.utils';
import {
  BudgetIssueCurrencyPickerData,
  openBudgetIssueCurrencyPicker,
} from '../../../../opportunities/components/budget-issue-currency-picker/budget-issue-currency-picker.component';
import { OportunitiesAddDrawerComponent } from '../../../../opportunities/drawers/oportunities-add-drawer/oportunities-add-drawer.component';
import { CreateProjectDrawerComponent } from '../../../../project/drawers/create-project-drawer/create-project-drawer.component';
import { ConvertLeadDrawerComponent } from '../../../../opportunities/drawers/convert-lead-drawer/convert-lead-drawer.component';
import { OpportunitiesBudgetDrawerComponent } from '../../../../opportunities/drawers/opportunities-budget-drawer/opportunities-budget-drawer.component';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { OportunitiesDetailsActivityDrawerComponent } from '../../../../opportunities/drawers/oportunities-details-activity-drawer/oportunities-details-activity-drawer.component';
import { ProjectUtilsService } from '../../../services/project-utils.service';
import { ServiceOrderRefreshService } from '../../../../opportunities/services/project-utils.service';

@Component({
  selector: 'app-oportunities-details-drawer',
  standalone: false,
  templateUrl: './orders-details-activities-drawer.component.html',
  styleUrl: './orders-details-activities-drawer.component.less',
})
export class OrdersDetailsActivitiesDrawerComponent
  implements OnInit, AfterViewInit, OnChanges
{
  nzData: {
    columnsData: TableColumn[];
    element: any; // Using 'any' to handle possible differences in the Partner model
    maestroName: string;
    editPermissions: boolean;
    serviceId?: number; // ID del servicio para filtrar flows
    opportunityList?: any[]; // Lista de oportunidades para navegación
  } = inject(NZ_DRAWER_DATA);

  serviceOrder: any = null;

  // Getter para mantener compatibilidad con código existente que usa 'opportunity'
  get opportunity(): any {
    return this.serviceOrder;
  }

  set opportunity(value: any) {
    this.serviceOrder = value;
  }
  columnsData: TableColumn[] = [];
  documents: any[] = [];
  stages: any[] = [];
  companies: any[] = [];
  costCenters: any[] = [];
  tags: CrmTag[] = [];
  lostReasons: any[] = [];

  loading: boolean = false;
  markingAsLost: boolean = false;
  recoveringLead: boolean = false;
  markAsLostModalRef: NzModalRef | null = null;
  lostForm!: FormGroup;
  isLost: boolean = false;
  isWon: boolean = false;
  afterViewInit: boolean = false;
  activeTabIndex: number = 0;
  isLead: boolean = false;
  private opportunityBackup: any = null;
  private originalOpportunityName: string = '';

  // Actividades
  activities: Activity[] = [];
  activitiesGroupedByDate: {
    date: string;
    label: string;
    activities: Activity[];
  }[] = [];
  loadingActivities: boolean = false;
  private activitiesLoaded = false;
  canCreateQuote: boolean = false;

  // View mode: 'opportunity' | 'lead' | 'budget'
  viewMode: 'opportunity' | 'lead' | 'budget' = 'opportunity';

  // Budget view data
  budget: any = null;
  budgetList: any[] = [];
  currentBudgetIndex: number = 0;
  private budgetModeOpportunityBackup: any = null;
  private budgetBackup: any = null;

  // Flag para evitar navegaciones durante la inicialización
  private isInitializing: boolean = true;

  // Control de visibilidad del panel de actividades en móvil
  showActivitiesPanel: boolean = false;

  // Control para manejar el botón atrás del navegador cuando el drawer está abierto
  private handlingBrowserBack: boolean = false;

  // Propiedades computadas (en lugar de funciones en la vista)
  opportunityName: string = '-';
  currentOpportunityId: number = 0;
  opportunityUsers: any[] = [];
  budgetName: string = '-';
  hasBudgetQuotationLines: boolean = false;
  generatingVersion: boolean = false; // Loading específico para generar una versión PDF del presupuesto
  pdfVersionsRefreshKey: number = 0; // Se incrementa para recargar la pestaña "Versiones"
  hasMultipleOpportunities: boolean = false;
  hasMultipleBudgets: boolean = false;

  // Stepper properties
  stagesForTeam: any[] = [];
  flows: any[] = [];
  currentStageName: string = 'Nuevo';
  // Etapas movibles del presupuesto (sin Cancelado: este stepper decorativo nunca lo muestra)
  protected readonly budgetStages: readonly BudgetStage[] = BUDGET_STAGES.filter(
    (s) => s.value !== 'Cancelled',
  );
  currentBudgetStageName: string = 'Presupuesto';
  currentBudgetStageValue: string = 'Budget'; // Valor del backend

  // Edición inline - similar a list-key-value: cada campo se edita individualmente
  backupFieldValues: { [key: string]: any } = {}; // Valores de respaldo por campo (para revertir cambios en caso de error)
  isEditModeEnabled: boolean = false; // Modo de edición general (activado por el botón)
  editModeAction: 'none' | 'save' | 'cancel' = 'none'; // Acción actual en modo edición
  private payloadToSave: any = null;

  // Edición de presupuesto
  isBudgetEditModeEnabled: boolean = false; // Modo de edición para presupuesto
  budgetEditModeAction: 'none' | 'save' | 'cancel' = 'none'; // Acción actual en modo edición de presupuesto
  private budgetBackupForEdit: any = null; // Backup del presupuesto para edición
  savingBudget: boolean = false; // Loading específico para guardar presupuesto
  cancelingBudget: boolean = false; // Loading específico para cancelar presupuesto
  recoveringBudget: boolean = false; // Loading específico para recuperar presupuesto
  requestingApproval: boolean = false; // Loading específico para solicitar aprobación
  savingServiceOrder: boolean = false; // Loading específico para guardar service order
  confirmingBudget: boolean = false; // Loading específico para confirmar presupuesto
  adoptingBudget: boolean = false; // Loading específico para adoptar presupuesto

  // Notificaciones
  notRef: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  @ViewChild('markAsLostModalTmpl') markAsLostModalTmpl!: TemplateRef<any>;
  @ViewChild('completionModalTmpl') completionModalTmpl!: TemplateRef<any>;
  @ViewChild('confirmationModal')
  confirmationModal!: ConfirmationModalComponent;
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Oportunidad actualizada.',
    showUndo: false,
  };

  // Estado del evento para cambio de estado
  private pendingEvent?: EventType;
  private pendingEventForEdit?: EventType;
  eventDate: Date = new Date();
  confirmationModalConfig: ConfirmationModalConfig = {
    title: 'Cambiar estado',
    message: '¿Deseas cambiar a este estado?',
    confirmText: 'Cambiar',
    cancelText: 'Cancelar',
    confirmButtonType: 'primary',
    confirmButtonDanger: false,
    showTextarea: false,
    showDatePicker: true,
    dateValue: new Date(),
    dateRequired: true,
  };

  opportunityStages = [
    { name: 'Nuevo', order: 1 },
    { name: 'Evaluación', order: 2 },
    { name: 'Presupuesto', order: 3 },
    { name: 'Pausada', order: 4 },
    { name: 'Adjudicada', order: 5 },
    { name: 'Cancelada', order: 6 },
  ];

  @Output() openEditDrawerEvent = new EventEmitter<number>();
  @Output() changeOpportunityEvent = new EventEmitter<{
    isNext: boolean;
    isPrev: boolean;
    id: number;
  }>();
  @Output() createNewOpportunityEvent = new EventEmitter<void>();
  @Output() deleteEvent = new EventEmitter<number>();
  @Output() updateEvent = new EventEmitter<any>();
  @Output() deleteServiceOrderEvent = new EventEmitter<number>();
  @Output() createSubtaskEvent = new EventEmitter<void>();
  protected readonly getSafeImageUrl = getSafeImageUrl;

  private destroyRef = inject(DestroyRef);
  protected readonly globalValuesService = inject(GlobalValuesService);
  protected readonly authService = inject(AuthService);
  protected readonly ps = inject(ProjectUtilsService);

  constructor(
    private drawerRef: NzDrawerRef<string>,
    private documentService: DocumentService,
    private projectService: ProjectService,
    private communicationService: CommunicationService,
    private opportunityService: OpportunityService,
    private activityService: ActivityService,
    private stServiceService: StServiceService,
    private flowEventService: FlowEventService,
    private fb: FormBuilder,
    private notificationService: NzNotificationService,

    private modalService: NzModalService,
    private opportunitiesUtilsService: OpportunitiesUtilsService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    private drawerService: NzDrawerService,
    public screenService: ScreenService,
    private router: Router,
    private route: ActivatedRoute,
    private serviceOrderRefreshService: ServiceOrderRefreshService,
    private detailsHelper: OpportunityDetailsHelperService,
    private stageService: OpportunityStageService,
    private payloadBuilder: OpportunityPayloadBuilderService,
    private drawerEscapeBlocker: DrawerEscapeBlockerService,
  ) {
    this.initLostForm();
  }

  ngOnInit(): void {
    this.loading = true;
    this.activitiesLoaded = false;
    this.serviceOrder = this.nzData.element;
    this.opportunity = this.nzData.element; // Asignar también opportunity para compatibilidad
    this.columnsData = this.nzData.columnsData;

    // Cargar flows desde el endpoint getFlow
    this.loadFlows();

    // Guardar el nombre original de la opportunity antes de cualquier mapeo
    if (
      this.opportunity?.name &&
      !this.opportunity.name.includes('@') &&
      !this.opportunity.name.includes(' ')
    ) {
      // Si el name parece ser un nombre de oportunidad real (no un contactName), guardarlo
      this.originalOpportunityName = this.opportunity.name;
    }

    // Inicializar isLead basado en maestroName o type
    this.isLead =
      this.nzData.maestroName === 'Leads' || this.opportunity?.type === 'Lead';

    // Inicializar viewMode basado en la ruta actual
    this.initializeViewModeFromRoute();

    // Inicializar isLost basado en dateLost
    this.updateIsLost();

    // Inicializar isWon basado en dateWon

    // Suscribirse al evento de cerrar todos los drawers
    this.ps.closeAllDrawers$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((shouldClose: boolean) => {
        if (shouldClose) {
          this.close();
        }
      });
    this.updateIsWon();

    // Actualizar canCreateQuote
    this.updateCanCreateQuote();

    // Actualizar etapas del stepper
    this.updateStagesForTeam();
    this.updateCurrentStageName();

    // Actualizar propiedades computadas
    this.updateComputedProperties();

    // Sincronizar URL con el estado actual (solo si no estamos ya en la ruta correcta)
    // Usar setTimeout para evitar conflictos con la apertura del drawer
    setTimeout(() => {
      this.isInitializing = false;
      this.updateUrlFromState();
    }, 100);

    // Cerrar el drawer si el usuario presiona atrás del navegador (popstate)
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(
          (event: any) =>
            event instanceof NavigationStart &&
            (event as NavigationStart).navigationTrigger === 'popstate',
        ),
      )
      .subscribe(() => {
        this.handleBrowserBackNavigation();
      });

    // Escuchar cambios en la ruta y query params para actualizar la vista
    // Combinar params y queryParams para detectar cambios en ambos
    // Para Service Orders, no necesitamos manejar cambios de ruta complejos

    // Load reference data
    this.loadStages();
    this.loadCompanies();
    this.loadCostCenters();
    this.loadTags();
    this.loadLostReasons();

    // Load chat if chatId exists
    if (this.opportunity?.chatId) {
      this.loadOpportunityChat();
    }

    // Get the documents if available or load them
    if (this.opportunity?.documents?.length) {
      this.documents = this.opportunity.documents;
    } else if (this.opportunity?.id || this.opportunity?.originalId) {
      this.loadOpportunityDocuments(
        this.opportunity?.id || this.opportunity?.originalId,
      );
    }

    // Cargar presupuestos al abrir el drawer (solo si no es lead o si estamos en modo budget)
    if (
      (!this.isLead || this.viewMode === 'budget') &&
      (this.opportunity?.id || this.opportunity?.originalId)
    ) {
      this.loadBudgets();

      // Si estamos en modo budget y hay un budgetId en la ruta o query params, cargar ese presupuesto después de cargar la lista
      const routeParams = this.route.snapshot.params;
      const queryParams = this.route.snapshot.queryParams;
      const budgetId = routeParams['budgetId'] || queryParams['budget'];
      if (this.viewMode === 'budget' && budgetId) {
        const budgetIdNum = Number(budgetId);
        // Usar setTimeout para asegurar que los presupuestos se carguen primero
        setTimeout(() => {
          this.loadSpecificBudget(budgetIdNum);
        }, 100);
      }
    }

    // Cargar actividades al abrir el drawer
    if (this.opportunity?.id || this.opportunity?.originalId) {
      this.loadActivities();
    }

    this.loading = false;
    this.drawerEscapeBlocker.block();
  }

  ngAfterViewInit(): void {
    this.afterViewInit = true;

    // En algunos entornos los inputs pueden llegar después de OnInit.
    // Forzamos una verificación diferida para cargar actividades.
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['opportunity'] &&
      (this.opportunity?.id || this.opportunity?.originalId) &&
      !this.activitiesLoaded
    ) {
      this.loadActivities();
    }
  }

  // Método público para actualizar la oportunidad desde el componente padre
  // Este método se llama cuando el componente padre actualiza directamente this.opportunity
  updateOpportunityData(newOpportunity: any): void {
    if (!newOpportunity) return;

    // Actualizar la oportunidad
    this.opportunity = newOpportunity;

    // Actualizar isLead basado en el tipo
    this.isLead =
      this.nzData.maestroName === 'Leads' || newOpportunity?.type === 'Lead';

    // Actualizar viewMode si es necesario (no cambiar si estamos en modo budget)
    if (this.viewMode !== 'budget') {
      this.viewMode = this.isLead ? 'lead' : 'opportunity';
    }

    // Actualizar estados
    this.updateIsLost();
    this.updateIsWon();
    this.updateCanCreateQuote();

    // Actualizar etapas del stepper
    this.updateStagesForTeam();
    this.updateCurrentStageName();

    // Actualizar propiedades computadas (nombre, ID, usuarios, etc.)
    this.updateComputedProperties();

    // Recargar documentos si es necesario
    if (newOpportunity?.id || newOpportunity?.originalId) {
      const opportunityId = newOpportunity.id || newOpportunity.originalId;
      if (
        !this.documents?.length ||
        this.documents[0]?.entityId !== opportunityId
      ) {
        this.loadOpportunityDocuments(opportunityId);
      }
    }

    // Recargar presupuestos si no estamos en modo lead o si estamos en modo budget
    if (
      (!this.isLead || this.viewMode === 'budget') &&
      (newOpportunity?.id || newOpportunity?.originalId)
    ) {
      this.loadBudgets();
    }

    // Recargar actividades si no se han cargado
    if (
      !this.activitiesLoaded &&
      (newOpportunity?.id || newOpportunity?.originalId)
    ) {
      this.loadActivities();
    }

    // Forzar detección de cambios
    this.cdr.detectChanges();
  }

  loadStages(): void {
    this.globalValuesService.stages$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((stages: { id: number; name: string }[]) => {
        this.stages = stages || [];
      });
  }

  loadCompanies(): void {
    this.globalValuesService.companies$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((companies: Company[]) => {
        this.companies = companies || [];
      });
  }

  loadCostCenters(): void {
    this.globalValuesService.costCenters$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((costCenters: { id: number; name: string }[]) => {
        this.costCenters = costCenters || [];
      });
  }

  loadTags(): void {
    this.globalValuesService.crmTags$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((tags: CrmTag[]) => {
        this.tags = tags || [];
      });
  }

  loadLostReasons(): void {
    // Opciones de razón de pérdida según la imagen
    this.lostReasons = [
      { id: 1, name: 'Precio' },
      { id: 2, name: 'Plazo' },
      { id: 3, name: 'Capacidad' },
      { id: 4, name: 'Negociación' },
      { id: 5, name: 'Otros' },
      { id: 6, name: 'No interesa' },
      { id: 7, name: 'Error' },
      { id: 8, name: 'No hay suficiente stock' },
      { id: 9, name: 'Escriba algo...' },
    ];
  }

  // Actualizar la propiedad isLost basada en dateLost
  updateIsLost(): void {
    this.isLost =
      this.opportunity?.dateLost !== null &&
      this.opportunity?.dateLost !== undefined;
  }

  // Actualizar la propiedad isWon basada en dateWon
  updateIsWon(): void {
    this.isWon =
      this.opportunity?.dateWon !== null &&
      this.opportunity?.dateWon !== undefined;
  }

  // Métodos para acciones de service orders
  deleteCurrentServiceOrder(): void {
    if (this.serviceOrder?.id) {
      this.deleteServiceOrderEvent.emit(this.serviceOrder.id);
      // NO cerrar el drawer aquí - esperar a que la eliminación se complete exitosamente
    }
  }

  createSubtask(): void {
    this.createSubtaskEvent.emit();
    // NO cerrar el drawer aquí - permanecer abierto hasta que se complete la creación
  }

  // Manejar el botón atrás del navegador cerrando el drawer y refrescando la tabla
  private handleBrowserBackNavigation(): void {
    if (this.handlingBrowserBack) return;
    this.handlingBrowserBack = true;

    // Limpiar estados de edición sin navegar
    if (this.viewMode === 'budget' && this.isBudgetEditModeEnabled) {
      this.budgetEditModeAction = 'cancel';
      this.cdr.detectChanges();

      if (this.budgetBackupForEdit) {
        this.budget = JSON.parse(JSON.stringify(this.budgetBackupForEdit));
      }

      this.budgetEditModeAction = 'none';
      this.isBudgetEditModeEnabled = false;
      this.budgetBackupForEdit = null;
      this.cdr.detectChanges();
    } else if (this.isEditModeEnabled && this.opportunityBackup) {
      this.editModeAction = 'cancel';
      this.cdr.detectChanges();

      if (this.opportunityBackup) {
        this.opportunity = JSON.parse(JSON.stringify(this.opportunityBackup));
        this.opportunityBackup = null;
      }

      this.isEditModeEnabled = false;
      this.editModeAction = 'none';
    }

    // Refrescar tabla de subtareas y cerrar drawer
    this.updateEvent.emit({ drawerClosed: true, reloadTable: true });
    this.serviceOrderRefreshService.triggerRefresh();
    this.drawerRef.close('reload');
  }

  close(): void {
    // Limpiar estados de edición silenciosamente sin mostrar notificaciones
    // NO restaurar valores al backend, solo limpiar el estado local
    if (this.viewMode === 'budget' && this.isBudgetEditModeEnabled) {
      // Primero enviar señal de cancelar al componente hijo
      this.budgetEditModeAction = 'cancel';
      this.cdr.detectChanges();

      // Restaurar el presupuesto desde el backup (cancelar cambios)
      if (this.budgetBackupForEdit) {
        this.budget = JSON.parse(JSON.stringify(this.budgetBackupForEdit));
      }

      // Limpiar el estado de edición
      this.budgetEditModeAction = 'none';
      this.isBudgetEditModeEnabled = false;
      this.budgetBackupForEdit = null;
      this.cdr.detectChanges();
    } else if (this.isEditModeEnabled && this.opportunityBackup) {
      // Cancelar edición de service order sin mostrar mensajes
      this.editModeAction = 'cancel';
      this.cdr.detectChanges();

      if (this.opportunityBackup) {
        this.opportunity = JSON.parse(JSON.stringify(this.opportunityBackup));
        this.opportunityBackup = null;
      }

      this.isEditModeEnabled = false;
      this.editModeAction = 'none';
    }

    // Recargar la lista de service orders antes de cerrar
    this.updateEvent.emit({ drawerClosed: true, reloadTable: true });

    // También hacer la petición HTTP para asegurar que se recarga
    this.serviceOrderRefreshService.triggerRefresh();
    // Cerrar el drawer completamente de una vez
    this.drawerRef.close('reload');

    // Navegar al detalle del proyecto/servicio
    const projectId =
      this.opportunity?.service?.project?.id || this.opportunity?.projectId;
    const navigationServiceId =
      this.opportunity?.service?.id || this.opportunity?.serviceId;
    const route = `/projects/detail/${projectId}/service/${navigationServiceId}`;
    this.router.navigate([route], { replaceUrl: true });
  }

  // Load the documents for this opportunity or service order
  loadOpportunityDocuments(entityId: number): void {
    // Determinar el tipo de entidad:
    // - ServiceOrder: tiene serviceId o service (propiedades específicas de service order)
    // - Opportunity: tiene type (Lead/Opportunity) o no tiene serviceId/service
    const hasServiceId =
      this.serviceOrder?.serviceId !== undefined &&
      this.serviceOrder?.serviceId !== null;
    const hasService = this.serviceOrder?.service !== undefined;
    const hasType =
      this.serviceOrder?.type === 'Opportunity' ||
      this.serviceOrder?.type === 'Lead';

    // Es ServiceOrder si tiene serviceId o service, y no tiene type
    const isServiceOrder = (hasServiceId || hasService) && !hasType;

    const entityType = isServiceOrder ? 'ServiceOrder' : 'Opportunity';

    const getParams = {
      startRow: 0,
      endRow: 100,
      sortDirection: 'asc',
      sortProperty: 'id',
      entityId: entityId,
      entityType: entityType,
    };

    this.documentService.getDocument(getParams).subscribe({
      next: (response) => {
        if (response && response.data && response.data.rows) {
          this.documents = response.data.rows;
        }
      },
      error: (error) => {
        console.error('Error loading documents:', error);
      },
    });
  }

  // Load the chat for this opportunity
  loadOpportunityChat(): void {
    if (!this.opportunity?.chatId) return;

    const chatParams: GetParams = {
      startRow: 0,
      endRow: 1,
      sortProperty: 'id',
      sortDirection: 'asc',
      filterProperty: 'id',
      filterValue: this.opportunity.chatId.toString(),
    };

    this.communicationService
      .getChat(chatParams)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          const loadedChat = response?.data?.rows?.[0];
          if (loadedChat) {
            // Preservar los mensajes existentes si el chat ya tiene mensajes cargados
            // y el nuevo chat no trae mensajes o tiene menos
            if (this.opportunity?.chat?.chatMessages?.length > 0) {
              // Si el chat cargado tiene mensajes, usar esos (más actualizados)
              if (
                loadedChat.chatMessages &&
                loadedChat.chatMessages.length > 0
              ) {
                this.opportunity.chat = {
                  ...loadedChat,
                  chatMessages: loadedChat.chatMessages,
                };
              } else {
                // Si no trae mensajes, mantener los existentes pero actualizar el resto del chat
                this.opportunity.chat = {
                  ...loadedChat,
                  chatMessages: this.opportunity.chat.chatMessages,
                };
              }
            } else {
              // Si no hay mensajes existentes, usar el chat cargado
              this.opportunity.chat = loadedChat;
              if (!this.opportunity.chat.chatMessages) {
                this.opportunity.chat['chatMessages'] = [];
              }
            }
            // Forzar detección de cambios para que el componente chat se actualice
            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          console.error('Error loading chat:', error);
        },
      });
  }

  // Get stage name by ID, considerando teamId
  getStageName(stageId: number | null): string {
    if (stageId === null || stageId === undefined) return '-';

    const teamId = this.opportunity?.teamId;
    const allStages = this.globalValuesService.stages$.value;

    // Buscar el stage por stageId y teamId (si está disponible)
    let stage: any = null;

    if (teamId) {
      // Buscar stage que coincida con stageId y teamId (o salesTeamId)
      stage = allStages.find(
        (s: any) =>
          s.id === stageId &&
          (s.teamId === teamId ||
            s.salesTeamId === teamId ||
            s.salesTeam?.id === teamId),
      );
    }

    // Si no se encuentra con teamId, buscar solo por stageId
    if (!stage) {
      stage = allStages.find((s: any) => s.id === stageId);
    }

    return stage?.name || '-';
  }

  // Obtener las etapas filtradas por teamId de la oportunidad, ordenadas
  getStagesForTeam(): any[] {
    const teamId = this.opportunity?.teamId;
    const allStages = this.globalValuesService.stages$.value;

    let filteredStages: any[] = [];

    // Si hay teamId, filtrar por teamId
    if (teamId) {
      filteredStages = allStages.filter(
        (s: any) =>
          s.teamId === teamId ||
          s.salesTeamId === teamId ||
          s.salesTeam?.id === teamId,
      );
    } else {
      // Si no hay teamId, retornar todas las etapas
      filteredStages = allStages;
    }

    // Ordenar por order si existe, sino por id
    return filteredStages.sort((a, b) => {
      if (a.order !== undefined && b.order !== undefined) {
        return a.order - b.order;
      }
      return (a.id || 0) - (b.id || 0);
    });
  }

  // Cargar flows desde el endpoint getFlow
  loadFlows(): void {
    const getParams = {
      startRow: 0,
      endRow: 100,
      sortDirection: 'asc',
      sortProperty: 'id',
    };

    // Usar serviceId del nzData si está disponible, sino usar el del opportunity como fallback
    const serviceId = this.nzData.serviceId || this.opportunity?.serviceId;

    this.flowEventService
      .getFlow({
        startRow: 0,
        endRow: 100,
        sortDirection: 'asc',
        sortProperty: 'id',
        ...(serviceId && {
          filterProperty: 'serviceId',
          filterValue: serviceId.toString(),
        }),
      })
      .subscribe({
        next: (response: any) => {
          if (response?.data?.rows) {
            this.flows = response.data.rows;
            // Procesar flows para poblar la propiedad activator de los eventos
            this.globalValuesService.setEventFlow(this.flows);
            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          console.error('Error cargando flows:', error);
        },
      });
  }

  // Obtener el nombre del flow correspondiente a un stage
  getFlowName(stage: any): string {
    if (!stage) return '-';

    // Si el stage tiene un flowId, buscar el flow correspondiente
    if (stage.flowId) {
      const flow = this.globalValuesService.flows$.value.find(
        (f: any) => f.id === stage.flowId,
      );
      return flow?.name || stage.name || '-';
    }

    // Si el stage tiene una propiedad flow directamente
    if (stage.flow?.name) {
      return stage.flow.name;
    }

    // Fallback al nombre del stage
    return stage.name || '-';
  }

  // Obtener la etapa actual del service order
  getCurrentStage(): any {
    const stageId = this.opportunity?.stageId;
    if (stageId === null || stageId === undefined) return null;

    const teamId = this.opportunity?.teamId;
    const allStages = this.globalValuesService.stages$.value;

    // Buscar el stage por stageId y teamId (si está disponible)
    let stage: any = null;

    if (teamId) {
      // Buscar stage que coincida con stageId y teamId (o salesTeamId)
      stage = allStages.find(
        (s: any) =>
          s.id === stageId &&
          (s.teamId === teamId ||
            s.salesTeamId === teamId ||
            s.salesTeam?.id === teamId),
      );
    }

    // Si no se encuentra con teamId, buscar solo por stageId
    if (!stage) {
      stage = allStages.find((s: any) => s.id === stageId);
    }

    return stage;
  }

  // Actualizar la propiedad canCreateQuote basándose en la etapa actual
  updateCanCreateQuote(): void {
    const currentStage = this.getCurrentStage();
    this.canCreateQuote = currentStage?.canCreateQuote === true;
  }

  // Obtener el icono para una etapa según su posición en el orden
  getStageIcon(index: number): string {
    return this.stageService.opportunityStages[index]
      ? this.detailsHelper.getStageIcon(index)
      : 'circle';
  }

  // Obtener el color para una etapa según su posición en el orden
  getStageColor(index: number): string {
    return this.detailsHelper.getStageColor(index);
  }

  // Obtener la clase CSS para el hover de una etapa según su posición en el orden
  getStageHoverClass(index: number): string {
    return this.detailsHelper.getStageHoverClass(index);
  }

  // Get contact name
  getContactName(): string {
    // Primero intentar obtener del objeto partner si existe
    if (this.opportunity?.contactPartner) {
      const contact = this.opportunity.contactPartner;
      return (
        [contact.name, contact.surName].filter(Boolean).join(' ').trim() || '-'
      );
    }
    // Si no existe, buscar por partnerId en la lista de partners
    if (this.opportunity?.partnerId) {
      const partner = this.globalValuesService.partnerlist?.find(
        (p) => p.id === this.opportunity.partnerId,
      );
      if (partner) {
        return (
          [partner.name, partner.surName].filter(Boolean).join(' ').trim() ||
          partner.name ||
          '-'
        );
      }
    }
    return '-';
  }

  // Get commercial name
  getCommercialName(): string {
    return this.detailsHelper.getCommercialName(this.opportunity);
  }

  // Toggle del modo de edición general
  toggleEditMode(): void {
    this.isEditModeEnabled = !this.isEditModeEnabled;
  }

  startEditMode(): void {
    if (this.isEditModeEnabled) return;

    // Crear backup con el nombre correcto preservado
    this.opportunityBackup = this.opportunity
      ? {
          ...JSON.parse(JSON.stringify(this.opportunity)),
          name:
            this.originalOpportunityName ||
            this.opportunity.oportunidad ||
            this.opportunity.originalOpportunityName ||
            this.opportunity.name,
        }
      : null;

    this.isEditModeEnabled = true;
    this.cdr.detectChanges();
  }

  async saveEditMode(): Promise<void> {
    if (this.savingServiceOrder) return; // Evitar múltiples clics

    this.savingServiceOrder = true;
    this.cdr.detectChanges();

    try {
      // Notificar al componente hijo que se va a guardar
      this.editModeAction = 'save';
      this.cdr.detectChanges();

      // Guardar todos los cambios pendientes de forma secuencial y esperar a que terminen
      await this.saveAllPendingChanges();

      // Una vez que todos los cambios se guardaron, enviar mensaje y limpiar estado
      this.opportunityBackup = null;
      this.isEditModeEnabled = false;
      this.sendServiceOrderSavedMessage();
      this.cdr.detectChanges();
    } finally {
      this.savingServiceOrder = false;
      this.cdr.detectChanges();
    }
  }

  private async saveAllPendingChanges(): Promise<void> {
    if (!this.opportunityBackup || !this.serviceOrder) {
      // Si no hay backup, no hay cambios para guardar
      return;
    }

    const serviceOrderId =
      this.serviceOrder?.id || this.serviceOrder?.originalId;
    if (!serviceOrderId) {
      console.error('No se pudo identificar el service order');
      return;
    }

    // Construir payload específico para service orders con campos editables
    const patchPayload: any = {
      id: serviceOrderId,
    };

    // Agregar solo los campos que se pueden editar en el drawer
    if (this.serviceOrder?.assignedUserId !== undefined) {
      patchPayload.assignedToId = this.serviceOrder.assignedUserId;
    }
    if (this.serviceOrder?.startDate !== undefined) {
      patchPayload.startDate = this.serviceOrder.startDate;
    }
    if (this.serviceOrder?.endDate !== undefined) {
      patchPayload.endDate = this.serviceOrder.endDate;
    }
    if (this.serviceOrder?.expectedClosure !== undefined) {
      patchPayload.expectedClosure = this.serviceOrder.expectedClosure;
    }
    if (this.serviceOrder?.costCenterId !== undefined) {
      patchPayload.costCenterId = this.serviceOrder.costCenterId;
    }
    if (this.serviceOrder?.priority !== undefined) {
      patchPayload.priority = this.serviceOrder.priority;
    }
    if (this.serviceOrder?.subtaskName !== undefined) {
      patchPayload.subtaskName = this.serviceOrder.subtaskName;
    }

    try {
      // Solo service orders - usar el endpoint correspondiente
      const updateObservable =
        this.stServiceService.patchServiceOrder(patchPayload);

      const response = await firstValueFrom(updateObservable);

      // Actualizar el service order con la respuesta del backend
      if (response?.data) {
        // 🔥 SINCRONIZAR SERVICE ORDER
        // IMPORTANTE: Actualizar this.serviceOrder (no this.opportunity que es solo un getter)
        // para que el componente OrderDetailsContentComponent refleje los cambios inmediatamente

        // Actualizar localmente con la respuesta, preservando objetos anidados
        // 🔥 CREAR NUEVA REFERENCIA COMPLETA para forzar change detection
        // 🔥 PRESERVAR assignedUserId local si el backend no lo devuelve correctamente
        const currentAssignedUserId = this.serviceOrder?.assignedUserId;

        // 🔥 LÓGICA CORRECTA: Si el backend devuelve assignedToId, usarlo para assignedUserId
        // Si no, mantener el valor local actual
        const finalAssignedUserId =
          response.data.assignedToId !== undefined
            ? response.data.assignedToId
            : response.data.assignedUserId !== undefined
              ? response.data.assignedUserId
              : currentAssignedUserId;

        // 🔥 PRESERVAR costCenter si el backend no lo devuelve
        // Si tenemos costCenterId pero el backend no devuelve costCenter, buscarlo localmente
        let finalCostCenter = response.data.costCenter;
        if (
          !finalCostCenter &&
          response.data.costCenterId &&
          this.costCenters?.length > 0
        ) {
          finalCostCenter = this.costCenters.find(
            (cc) => cc.id === response.data.costCenterId,
          );
        }
        if (!finalCostCenter) {
          finalCostCenter = this.serviceOrder?.costCenter;
        }

        const updatedServiceOrder = {
          ...this.serviceOrder,
          ...response.data,
          // Usar el valor correcto calculado arriba
          assignedUserId: finalAssignedUserId,
          // El componente OrderDetailsContentComponent ahora verifica consistencia internamente
          assignedTo: response.data.assignedTo || this.serviceOrder?.assignedTo,
          costCenter: finalCostCenter,
          service: response.data.service || this.serviceOrder?.service,
          documents: this.serviceOrder?.documents || [],
          chat: this.serviceOrder?.chat,
        };

        // Asignar nueva referencia para forzar change detection
        this.serviceOrder = updatedServiceOrder;

        // Forzar detección de cambios en el componente hijo
        this.cdr.detectChanges();

        // 🔥 SOLUCIÓN MENOS AGRESIVA: Marcar para verificación de cambios
        setTimeout(() => {
          this.cdr.markForCheck();
        }, 50);

        // Actualizar propiedades computadas
        this.updateComputedProperties();

        // Emitir el objeto actualizado
        this.updateEvent.emit({
          ...this.serviceOrder,
          skipReload: true, // Flag para indicar que no se necesita recargar
        });
      }

      const successMessage = 'Subtarea actualizada exitosamente.';
      this.showNotification(successMessage);
    } catch (error) {
      console.error('❌ Error guardando cambios:', error);
      const errorMessage = 'Error al guardar cambios del service order';
      this.showErrorNotification(errorMessage);
      throw error; // Re-throw para que el try/catch en saveEditMode lo maneje
    }
  }

  private hasValueChanged(current: any, backup: any): boolean {
    return this.detailsHelper.hasValueChanged(current, backup);
  }

  confirmCancelEditMode(): void {
    this.modalService.confirm({
      nzTitle: '¿Cancelar cambios?',
      nzContent:
        '¿Estás seguro de que deseas cancelar los cambios realizados? Se perderán todos los cambios no guardados.',
      nzOkText: 'Sí, cancelar',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzCancelText: 'No, continuar editando',
      nzOnOk: () => {
        this.cancelEditMode();
      },
    });
  }

  cancelEditMode(): void {
    // Notificar al componente hijo que se va a cancelar
    this.editModeAction = 'cancel';
    this.cdr.detectChanges();

    if (this.opportunityBackup) {
      this.opportunity = JSON.parse(JSON.stringify(this.opportunityBackup));

      // Enviar los valores restaurados al backend
      this.saveCurrentOpportunityToBackend();

      this.opportunityBackup = null;
    }
    this.isEditModeEnabled = false;
    this.cdr.detectChanges();
  }

  private sendServiceOrderSavedMessage(): void {
    try {
      if (!this.opportunity?.chat?.id) return;
      const loggedUser = this.authService.loggedUser$.value;
      if (!loggedUser?.id) return;

      const now = new Date();
      const dateStr = now.toLocaleString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      const message =
        `${this.getOpportunityName()}\n` +
        `Subtarea actualizada\n` +
        `${dateStr}`;
      const payload = {
        message,
        type: 'text',
        chatId: this.opportunity.chat.id,
        userId: loggedUser.id,
        authUserEmail: loggedUser.email,
        files: [],
      } as any;

      this.communicationService.createChatMessage(payload).subscribe({
        next: (rsp) => {
          // Actualizar localmente el chat si existe la lista
          if (this.opportunity?.chat && rsp?.data) {
            if (!Array.isArray(this.opportunity.chat.chatMessages)) {
              this.opportunity.chat.chatMessages = [];
            }
            // Usar el mensaje que devuelve el backend (incluye createdByName y otros campos)
            this.opportunity.chat.chatMessages.unshift(rsp.data);
            // Forzar referencia nueva para que el chat OnPush detecte el cambio
            // Primero actualizar el chat
            const updatedChat = {
              ...this.opportunity.chat,
              chatMessages: [...this.opportunity.chat.chatMessages],
            };
            // Luego actualizar la referencia completa de opportunity para que activities-panel detecte el cambio
            this.opportunity = {
              ...this.opportunity,
              chat: updatedChat,
            };
            this.cdr.detectChanges();
          }
        },
        error: (err) =>
          console.error('Error enviando mensaje de actualización', err),
      });
    } catch (err) {
      console.error('Error sendOpportunitySavedMessage', err);
    }
  }

  private sendBudgetSavedMessage(): void {
    try {
      if (!this.opportunity?.chat?.id) return;
      const loggedUser = this.authService.loggedUser$.value;
      if (!loggedUser?.id) return;

      const now = new Date();
      const dateStr = now.toLocaleString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      const budgetName = this.budget?.name || 'Presupuesto';
      const message =
        `${budgetName}\n` + `Presupuesto actualizado\n` + `${dateStr}`;
      const payload = {
        message,
        type: 'text',
        chatId: this.opportunity.chat.id,
        userId: loggedUser.id,
        authUserEmail: loggedUser.email,
        files: [],
      } as any;

      this.communicationService.createChatMessage(payload).subscribe({
        next: (rsp) => {
          // Actualizar localmente el chat si existe la lista
          if (this.opportunity?.chat && rsp?.data) {
            if (!Array.isArray(this.opportunity.chat.chatMessages)) {
              this.opportunity.chat.chatMessages = [];
            }
            // Usar el mensaje que devuelve el backend (incluye createdByName y otros campos)
            this.opportunity.chat.chatMessages.unshift(rsp.data);
            // Forzar referencia nueva para que el chat OnPush detecte el cambio
            // Primero actualizar el chat
            const updatedChat = {
              ...this.opportunity.chat,
              chatMessages: [...this.opportunity.chat.chatMessages],
            };
            // Luego actualizar la referencia completa de opportunity para que activities-panel detecte el cambio
            this.opportunity = {
              ...this.opportunity,
              chat: updatedChat,
            };
            this.cdr.detectChanges();
          }
        },
        error: (err) =>
          console.error(
            'Error enviando mensaje de actualización de presupuesto',
            err,
          ),
      });
    } catch (err) {
      console.error('Error sendBudgetSavedMessage', err);
    }
  }

  // Inicializar formulario para marcar como perdido
  initLostForm(): void {
    this.lostForm = this.fb.group({
      reason: [null],
      lostNote: [''],
    });
  }

  // Guardar la opportunity actual al backend sin comparaciones (para cancelaciones)
  private saveCurrentOpportunityToBackend(): void {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) {
      return;
    }

    // Para cancelar, enviamos la opportunity restaurada (ya corregida en cancelEditMode)
    // Construir el payload completo usando el método existente
    const opportunityName = this.getOpportunityName();
    const patchPayload = this.buildCompleteOpportunityPayload(
      'name',
      opportunityName,
    );

    // Solo service orders - usar el endpoint correspondiente
    const updateObservable =
      this.stServiceService.patchServiceOrder(patchPayload);

    updateObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response: any) => {
        // Actualizar la oportunidad con la respuesta del backend
        if (response?.data) {
          const updatedOpportunity =
            this.opportunitiesUtilsService.mapOpportunityData(response.data);
          if (updatedOpportunity) {
            this.opportunity = {
              ...this.opportunity,
              ...updatedOpportunity,
              documents: this.opportunity?.documents || [],
              chat: this.opportunity?.chat,
            };
            this.updateEvent.emit(this.opportunity);
          }
        }

        const cancelMessage = this.isLead
          ? 'Cambios del lead cancelados correctamente.'
          : 'Cambios de la subtarea cancelados correctamente.';
        this.showNotification(cancelMessage);

        //const route = this.isLead ? '/oportunities/leads' : '/oportunities';
        //this.router.navigate([route]);
      },
      error: (error) => {
        console.error('❌ Error guardando valores cancelados:', error);
        const errorMessage = this.isLead
          ? 'Error al cancelar cambios del lead'
          : 'Error al cancelar cambios de la oportunidad';
        this.showErrorNotification(errorMessage);
      },
    });
  }

  // Construir el payload completo para guardar todos los cambios
  private buildCompleteOpportunityPayloadForSave(changedFields: {
    [field: string]: any;
  }): any {
    // Función helper para extraer ID
    const getIdValue = (value: any): number | null => {
      if (value === null || value === undefined || value === '') return null;
      if (typeof value === 'object' && value?.id !== undefined) return value.id;
      if (typeof value === 'number') return value;
      if (typeof value === 'string' && !isNaN(Number(value)))
        return Number(value);
      return null;
    };

    // Incluir el ID y todos los campos actuales
    const payload: any = {
      id: this.opportunity?.id || this.opportunity?.originalId,
      name: this.opportunity?.name,
      description: this.opportunity?.description,
      amount: this.opportunity?.amount,
      stageId: getIdValue(this.opportunity?.stageId),
      userId: getIdValue(this.opportunity?.userId),
      teamId: getIdValue(this.opportunity?.teamId),
      dateDeadLine: this.opportunity?.dateDeadLine
        ? typeof this.opportunity.dateDeadLine === 'string'
          ? this.opportunity.dateDeadLine
          : new Date(this.opportunity.dateDeadLine).toISOString()
        : null,
      dateWon: this.opportunity?.dateWon
        ? typeof this.opportunity.dateWon === 'string'
          ? this.opportunity.dateWon
          : new Date(this.opportunity.dateWon).toISOString()
        : null,
      dateLost: this.opportunity?.dateLost
        ? typeof this.opportunity.dateLost === 'string'
          ? this.opportunity.dateLost
          : new Date(this.opportunity.dateLost).toISOString()
        : null,
      opportunityType: this.opportunity?.opportunityType,
      companyId: getIdValue(this.opportunity?.companyId),
      costCenterId: getIdValue(this.opportunity?.costCenterId),
      lostReasonId: getIdValue(this.opportunity?.lostReasonId),
      partnerId: getIdValue(this.opportunity?.partnerId),
      tags: this.opportunity?.tags,
      dateCreated: this.opportunity?.dateCreated
        ? typeof this.opportunity.dateCreated === 'string'
          ? this.opportunity.dateCreated
          : new Date(this.opportunity.dateCreated).toISOString()
        : null,
      dateLastActivity: this.opportunity?.dateLastActivity
        ? typeof this.opportunity.dateLastActivity === 'string'
          ? this.opportunity.dateLastActivity
          : new Date(this.opportunity.dateLastActivity).toISOString()
        : null,
      dateNextActivity: this.opportunity?.dateNextActivity
        ? typeof this.opportunity.dateNextActivity === 'string'
          ? this.opportunity.dateNextActivity
          : new Date(this.opportunity.dateNextActivity).toISOString()
        : null,
      countryId: getIdValue(this.opportunity?.countryId),
      stateId: getIdValue(this.opportunity?.stateId),
      chatId: getIdValue(this.opportunity?.chatId),
    };

    // Agregar los campos que cambiaron
    Object.keys(changedFields).forEach((field) => {
      if (field === 'tags') {
        payload.tagIds = changedFields[field];
      } else {
        payload[field] = changedFields[field];
      }
    });

    return payload;
  }

  // Método helper para construir el payload completo con todas las propiedades de la oportunidad
  private buildCompleteOpportunityPayload(path: string, value: any): any {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    const opportunityName = this.getOpportunityName();

    // Si es de tipo Date se transforma con toISOString
    const processedValue =
      typeof value === 'object' && value?.toISOString?.()
        ? value.toISOString()
        : value;

    // Helper para obtener valor de ID (null si es 0 o no existe)
    const getIdValue = (value: any): number | null => {
      return value && value !== 0 ? value : null;
    };

    // Construir el payload completo con todas las propiedades
    const payload: any = {
      id: opportunityId || 0,
      companyId:
        path === 'companyId'
          ? getIdValue(processedValue)
          : getIdValue(this.opportunity?.companyId),
      name:
        opportunityName ||
        this.opportunity?.name ||
        this.opportunity?.oportunidad ||
        this.opportunity?.originalOpportunityName ||
        '',
      type: this.opportunity?.type || 'Lead',
      opportunityType:
        path === 'opportunityType'
          ? processedValue
          : this.opportunity?.opportunityType || null,
      priority:
        path === 'priority'
          ? processedValue
          : this.opportunity?.priority || null,
      expectedRevenue:
        path === 'expectedRevenue'
          ? typeof processedValue === 'number'
            ? processedValue
            : typeof processedValue === 'string'
              ? parseFloat(processedValue)
              : 0
          : (this.opportunity?.expectedRevenue?.parsedValue ??
            (this.opportunity?.expectedRevenue?.source
              ? parseFloat(this.opportunity.expectedRevenue.source)
              : null) ??
            this.opportunity?.expectedRevenue ??
            0),
      probability:
        path === 'probability'
          ? typeof processedValue === 'number'
            ? processedValue
            : typeof processedValue === 'string'
              ? parseFloat(processedValue)
              : 0
          : this.opportunity?.probability || 0,
      expectedClosingDate:
        path === 'expectedClosingDate'
          ? processedValue
            ? typeof processedValue === 'string'
              ? processedValue
              : new Date(processedValue).toISOString()
            : null
          : this.opportunity?.expectedClosingDate
            ? typeof this.opportunity.expectedClosingDate === 'string'
              ? this.opportunity.expectedClosingDate
              : new Date(this.opportunity.expectedClosingDate).toISOString()
            : null,
      source: this.opportunity?.source || null,
      description:
        path === 'description'
          ? processedValue
          : this.opportunity?.description || null,
      email:
        path === 'email' ? processedValue : this.opportunity?.email || null,
      phone:
        path === 'phone' ? processedValue : this.opportunity?.phone || null,
      mobile: this.opportunity?.mobile || null,
      street:
        path === 'street' ? processedValue : this.opportunity?.street || null,
      street2: this.opportunity?.street2 || null,
      city: this.opportunity?.city || null,
      province: this.opportunity?.province || null,
      zip: this.opportunity?.zip || null,
      website:
        path === 'website' ? processedValue : this.opportunity?.website || null,
      clientCompany:
        path === 'clientCompany'
          ? processedValue
          : this.opportunity?.clientCompany || null,
      jobTitle:
        path === 'jobTitle'
          ? processedValue
          : this.opportunity?.jobTitle || null,
      isActive:
        this.opportunity?.isActive !== undefined
          ? this.opportunity.isActive
          : true,
      dateConversion: this.opportunity?.dateConversion
        ? typeof this.opportunity.dateConversion === 'string'
          ? this.opportunity.dateConversion
          : new Date(this.opportunity.dateConversion).toISOString()
        : null,
      dateWon: this.opportunity?.dateWon
        ? typeof this.opportunity.dateWon === 'string'
          ? this.opportunity.dateWon
          : new Date(this.opportunity.dateWon).toISOString()
        : null,
      dateLost: this.opportunity?.dateLost
        ? typeof this.opportunity.dateLost === 'string'
          ? this.opportunity.dateLost
          : new Date(this.opportunity.dateLost).toISOString()
        : null,
      dateLastActivity: this.opportunity?.dateLastActivity
        ? typeof this.opportunity.dateLastActivity === 'string'
          ? this.opportunity.dateLastActivity
          : new Date(this.opportunity.dateLastActivity).toISOString()
        : null,
      dateNextActivity: this.opportunity?.dateNextActivity
        ? typeof this.opportunity.dateNextActivity === 'string'
          ? this.opportunity.dateNextActivity
          : new Date(this.opportunity.dateNextActivity).toISOString()
        : null,
      partnerId:
        path === 'partnerId'
          ? getIdValue(processedValue)
          : getIdValue(this.opportunity?.partnerId),
      userId:
        path === 'userId'
          ? getIdValue(processedValue)
          : getIdValue(this.opportunity?.userId),
      teamId:
        path === 'teamId'
          ? getIdValue(processedValue)
          : getIdValue(this.opportunity?.teamId),
      stageId:
        path === 'stageId'
          ? getIdValue(processedValue)
          : getIdValue(this.opportunity?.stageId),
      lostReasonId: getIdValue(this.opportunity?.lostReasonId),
      countryId: getIdValue(this.opportunity?.countryId),
      stateId: getIdValue(this.opportunity?.stateId),
      chatId: getIdValue(this.opportunity?.chatId),
      costCenterId:
        path === 'costCenterId'
          ? getIdValue(processedValue)
          : getIdValue(this.opportunity?.costCenterId),
    };

    // Si el campo modificado no está en el payload base, agregarlo
    if (!payload.hasOwnProperty(path)) {
      // Si es tags, usar tagIds en el payload
      if (path === 'tags') {
        payload.tagIds = processedValue;
      } else {
        payload[path] = processedValue;
      }
    }

    return payload;
  }

  // Método genérico para actualizar un campo individual (similar a list-key-value)
  patchField(path: string, value: any): Observable<any> {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) {
      console.error('No se pudo identificar la oportunidad');
      return of(null);
    }

    // Manejo especial para tags: el endpoint de tags recibe operaciones individuales
    if (path === 'tags') {
      const tagIds = Array.isArray(value)
        ? value
            .map((tag: any) => (typeof tag === 'object' ? tag.id : tag))
            .filter((id: any) => id !== null && id !== undefined)
        : [];

      // Usar el backup guardado (debe venir de onFieldUpdate)
      const previousTagsRaw =
        this.backupFieldValues[path] !== undefined
          ? this.backupFieldValues[path]
          : [];

      const currentTagIds = Array.isArray(previousTagsRaw)
        ? previousTagsRaw
            .map((tag: any) => (typeof tag === 'object' ? tag.id : tag))
            .filter((id: any) => id !== null && id !== undefined)
        : [];

      const tagsToAdd = tagIds.filter(
        (id: number) => !currentTagIds.includes(id),
      );
      const tagsToRemove = currentTagIds.filter(
        (id: number) => !tagIds.includes(id),
      );

      // Si no hay cambios reales, salir
      if (tagsToAdd.length === 0 && tagsToRemove.length === 0) {
        return of(null);
      }

      const tagRequests: Observable<PostResponse>[] = [];

      tagsToAdd.forEach((id: number) => {
        tagRequests.push(this.opportunityService.addLeadTag(opportunityId, id));
      });

      tagsToRemove.forEach((id: number) => {
        tagRequests.push(
          this.opportunityService.removeLeadTag(opportunityId, id),
        );
      });

      if (tagRequests.length > 0) {
        return forkJoin(tagRequests).pipe(
          takeUntilDestroyed(this.destroyRef),
          map(() => {
            if (this.opportunity) {
              this.opportunity.tags = tagIds;
            }
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
            return null;
          }),
          catchError((error) => {
            console.error('Error actualizando tags:', error);
            // Revertir al valor previo
            if (this.opportunity && previousTagsRaw !== undefined) {
              this.opportunity.tags = previousTagsRaw;
              this.cdr.detectChanges();
            }
            throw error;
          }),
        );
      }

      return of(null);
    }

    // Validación para campos obligatorios (según opportunities-add-drawer.component.html):
    // - opportunityType (nzRequired)
    // - costCenterId (nzRequired como "costCenter")
    // - partnerId (nzRequired como "contact")
    // - teamId (nzRequired como "salesTeam")
    const requiredFields = [
      'opportunityType',
      'costCenterId',
      'partnerId',
      'teamId',
    ];
    if (requiredFields.includes(path) && (!value || value === '')) {
      console.warn(
        `${path} es obligatorio, no se puede enviar null. Revertiendo cambio.`,
      );
      // Revertir el cambio
      if (this.backupFieldValues[path] !== undefined && this.opportunity) {
        this.opportunity[path] = this.backupFieldValues[path];
        this.cdr.detectChanges();
      }
      return of(null);
    }

    // Construir el payload completo con todas las propiedades
    const patchPayload = this.buildCompleteOpportunityPayload(path, value);
    this.payloadToSave = patchPayload;

    // Determinar si es un lead o una oportunidad para usar el endpoint correcto
    const updateObservable = this.isLead
      ? this.opportunityService.patchLead(patchPayload)
      : this.opportunityService.patchOpportunity(patchPayload);

    // Retornar el observable para que el llamador pueda manejarlo
    return updateObservable.pipe(
      takeUntilDestroyed(this.destroyRef),
      map((response: any) => {
        // Actualizar la oportunidad con la respuesta del backend
        if (response?.data) {
          const updatedOpportunity =
            this.opportunitiesUtilsService.mapOpportunityData(response.data);
          if (updatedOpportunity) {
            // Preservar datos locales que no vienen del backend
            this.opportunity = {
              ...this.opportunity,
              ...updatedOpportunity,
              documents: this.opportunity?.documents || [],
              chat: this.opportunity?.chat,
            };
            // Actualizar isLost después de actualizar la oportunidad
            this.updateIsLost();
            // Actualizar isWon después de actualizar la oportunidad
            this.updateIsWon();
            // Actualizar canCreateQuote después de actualizar la oportunidad
            this.updateCanCreateQuote();
            // Emitir evento para actualizar el componente padre
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
          }
        } else if (response?.id) {
          const updatedOpportunity =
            this.opportunitiesUtilsService.mapOpportunityData(response);
          if (updatedOpportunity) {
            this.opportunity = {
              ...this.opportunity,
              ...updatedOpportunity,
              documents: this.opportunity?.documents || [],
              chat: this.opportunity?.chat,
            };
            // Actualizar isLost después de actualizar la oportunidad
            this.updateIsLost();
            // Actualizar isWon después de actualizar la oportunidad
            this.updateIsWon();
            // Actualizar canCreateQuote después de actualizar la oportunidad
            this.updateCanCreateQuote();
            // Emitir evento para actualizar el componente padre
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
          }
        } else {
          // Fallback: actualizar solo el campo específico
          if (this.opportunity) {
            // Si es de tipo Date se transforma con toISOString
            const processedValue =
              typeof value === 'object' && value?.toISOString?.()
                ? value.toISOString()
                : value;
            this.opportunity[path] = processedValue;
            // Actualizar isLost si se modificó dateLost
            if (path === 'dateLost') {
              this.updateIsLost();
            }
            // Actualizar isWon si se modificó dateWon
            if (path === 'dateWon') {
              this.updateIsWon();
            }
            // Actualizar canCreateQuote si se modificó stageId
            if (path === 'stageId') {
              this.updateCanCreateQuote();
            }
            // Emitir evento para actualizar el componente padre
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
          }
        }
        return response;
      }),
      catchError((error) => {
        console.error(`Error updating field ${path}:`, error);
        // Revertir el cambio visualmente si es necesario
        if (this.backupFieldValues[path] !== undefined && this.opportunity) {
          this.opportunity[path] = this.backupFieldValues[path];
          this.cdr.detectChanges();
        }
        // Re-emitir el error
        throw error;
      }),
    );
  }

  protected readonly isExpirationAlert = isExpirationAlert;

  // Get opportunity name (handles the mapping where name is overwritten with contact name)
  getOpportunityName(): string {
    // Para service orders, devolver el subtaskName o reference
    if (this.opportunity?.subtaskName) {
      return this.opportunity.subtaskName;
    }
    if (this.opportunity?.reference) {
      return this.opportunity.reference;
    }
    return this.opportunity?.id
      ? `Service Order ${this.opportunity.id}`
      : 'Service Order';
  }

  // Stage methods
  updateStagesForTeam(): void {
    if (this.isLead) {
      this.stagesForTeam = this.getStagesForTeam().filter(
        (stage) => stage.useForLeads === true,
      );
    } else {
      this.stagesForTeam = this.getStagesForTeam();
    }
  }

  updateCurrentStageName(): void {
    if (this.viewMode === 'budget') {
      // Para presupuesto, usar la etapa del presupuesto
      const stageValue = this.budget?.stage || 'Budget';
      this.currentBudgetStageValue = stageValue;
      const currentStage = this.budgetStages.find(
        (s) => s.value === stageValue,
      );
      this.currentBudgetStageName = currentStage?.name || 'Presupuesto';
    } else {
      // Para service order, usar la etapa del service order
      this.currentStageName =
        this.getStageName(this.opportunity?.stageId) || 'Nuevo';
    }
  }

  isCurrentStage(stageName: string): boolean {
    return this.currentStageName === stageName;
  }

  // Budget stage methods
  isCurrentBudgetStage(stageValue: string): boolean {
    return this.currentBudgetStageValue === stageValue;
  }

  // Espejo de canChangeToState (línea ~1976): predicado de elegibilidad para el
  // stepper de presupuesto, gateado en nzData.editPermissions per
  // quote-stage-lifecycle spec ("The stepper respects edit permission").
  canChangeToBudgetStage(stage: BudgetStage): boolean {
    if (!this.nzData.editPermissions) {
      return false;
    }
    if (!this.budget?.id || this.currentBudgetStageValue === stage.value) {
      return false;
    }
    // Cancellation carve-out (F-2): not applicable here — this decorative stepper
    // never lists Cancelled — but kept for parity with the other drawer's contract.
    if (stage.value !== 'Cancelled' && findBudgetStageBlock(this.budget)) {
      return false;
    }
    return true;
  }

  // Cambiar la etapa del presupuesto usando el endpoint correspondiente a cada destino
  changeBudgetStage(stage: BudgetStage): void {
    if (!this.canChangeToBudgetStage(stage)) {
      return;
    }

    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) {
      return;
    }

    const request$ =
      stage.route === 'confirm'
        ? this.opportunityService.confirmSaleOrder(this.budget.id, leadId)
        : stage.route === 'cancel'
          ? this.opportunityService.cancelSaleOrder(this.budget.id, leadId)
          : this.opportunityService.changeSaleOrderStage(this.budget.id, leadId, stage.value);

    request$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.budget = { ...this.budget, ...response.data };
          const index = this.budgetList.findIndex(
            (b: any) => b.id === this.budget.id,
          );
          if (index !== -1) {
            this.budgetList[index] = { ...this.budget };
          }
          this.updateComputedProperties();
          this.cdr.detectChanges();

          this.toastConfig = {
            icon: 'check_circle',
            iconColor: '#6CDA75',
            content: `El presupuesto se movió a "${stage.name}".`,
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        }
      },
      error: (error: any) => {
        console.error('Error changing budget stage:', error);
        this.toastConfig = {
          icon: 'dangerous',
          iconColor: '#CB2A2F',
          content: error.error?.message || 'No fue posible mover el presupuesto.',
          showUndo: false,
        };
        this.notRef = this.notificationService.create(
          'blank',
          '',
          this.notificationTmpl,
          { nzPlacement: 'bottomRight' },
        );
      },
    });
  }

  isCurrentEvent(event: any): boolean {
    if (!this.serviceOrder?.state || !event?.id) {
      return false;
    }
    return event.id.toString() === this.serviceOrder.state.toString();
  }

  // Ordenar eventos de un flujo por sequence
  getSortedFlowEvents(flow: any): any[] {
    if (!flow?.events) return [];
    // Ordenar por sequence de menor a mayor
    return [...flow.events].sort((a: any, b: any) => a.sequence - b.sequence);
  }

  // Métodos para cambio de estado del evento
  isNextState(event: any): {
    isNextState: boolean;
    date: string | undefined;
    integrationField: string | undefined;
  } {
    // Obtener el flujo que contiene este evento
    const flow = this.flows.find((f: any) =>
      f.events?.some((e: any) => e.id === event.id),
    );
    if (!flow?.events) {
      return {
        isNextState: true,
        date: undefined,
        integrationField: undefined,
      };
    }

    // Ordenar eventos por sequence para asegurar orden correcto
    const sortedEvents = [...flow.events].sort(
      (a: any, b: any) => a.sequence - b.sequence,
    );

    // Buscar el evento actual del serviceOrder
    const serviceOrderCurrentEvent = sortedEvents.find(
      (et: any) => et.id.toString() === this.serviceOrder?.state?.toString()
    );

    // Verificar si el evento ya existe en serviceOrder.events
    const eventData: any = this.serviceOrder?.events || [];
    const existingEvent = eventData
      .filter((e: any) => e.eventTypeId === event.id)
      .sort((a: any, b: any) => b.id - a.id)[0];

    let integrationField = existingEvent?.integrationField;
    const date = integrationField
      ? existingEvent?.integrationValue
      : existingEvent?.dateTime;

    // Si el evento ya existe, NO es un estado siguiente (es actual o anterior)
    if (existingEvent) {
      return { isNextState: false, date, integrationField };
    }

    // Si el evento NO existe en serviceOrder.events, verificar si es el siguiente inmediato
    let isNextState: boolean;
    
    if (serviceOrderCurrentEvent) {
      // Hay un evento actual - verificar si este evento es el siguiente inmediato
      // Buscar todos los eventos siguientes al actual
      const nextEvents = sortedEvents.filter(
        (e: any) => e.sequence > serviceOrderCurrentEvent.sequence
      );
      
      if (nextEvents.length > 0) {
        // Obtener el sequence del siguiente inmediato
        const nextImmediateSequence = Math.min(...nextEvents.map((e: any) => e.sequence));
        // Solo permitir cambiar al evento con el siguiente sequence inmediato
        isNextState = event.sequence === nextImmediateSequence;
      } else {
        // No hay eventos siguientes (estamos en el último estado)
        isNextState = false;
      }
    } else {
      // No hay evento actual - permitir solo el primer evento del flujo
      const minSequence = Math.min(...sortedEvents.map((e: any) => e.sequence));
      isNextState = event.sequence === minSequence;
    }

    return { isNextState, date, integrationField };
  }

  getPreviousEventType(current: any): any | undefined {
    // Obtener el flujo que contiene este evento
    const flow = this.flows.find((f: any) =>
      f.events?.some((e: any) => e.id === current.id),
    );
    if (!flow?.events) {
      return undefined;
    }

    // Ordenar eventos por sequence para asegurar orden correcto
    const sortedEvents = [...flow.events].sort(
      (a: any, b: any) => a.sequence - b.sequence,
    );

    // Buscar el evento inmediatamente anterior (sequence - 1)
    const previousEvent = sortedEvents.find(
      (e: any) => e.sequence === current.sequence - 1,
    );
    return previousEvent;
  }

  hasPreviousEventOccurred(current: any): boolean {
    // Obtener el evento inmediatamente anterior (sequence - 1)
    const previousEventType = this.getPreviousEventType(current);

    // Si no hay anterior, se asume que sí se puede continuar
    if (!previousEventType) {
      return true;
    }

    // Verifica si ya ocurrió al menos una vez ese evento anterior inmediato
    // (igual que service-order-drawer, solo verifica el inmediatamente anterior)
    const serviceOrderEvents = this.serviceOrder?.events || [];
    const hasOccurred = serviceOrderEvents.some(
      (e: any) => e.eventTypeId === previousEventType.id,
    );

    return hasOccurred;
  }

  canChangeToState(event: any): boolean {
    if (!this.isEditModeEnabled) {
      return false;
    }

    // Verificar que el evento es manual (puede cambiarse manualmente)
    // Verificar tanto eventClassId directo como eventClass.id anidado
    // También verificar eventTriggers directamente si activator no está disponible
    const isManual =
      event.eventClassId === 1 ||
      event.eventClass?.id === 1 ||
      event.activator?.name === 'Manual' ||
      event.eventTriggers?.some((et: any) => et.name === 'Manual');

    // Verificar permisos
    const hasPermission = !!this.authService.loggedUser$.value?.editSOUnlimited;

    // Verificar que todos los eventos anteriores ya ocurrieron
    const previousOccurred = this.hasPreviousEventOccurred(event);

    // Verificar que es un estado siguiente (no existe aún)
    const isNextStateResult = this.isNextState(event);
    const isNextState = isNextStateResult.isNextState;

    // Permitir cambiar si cumple todas las condiciones (igual que service-order-drawer)
    const canChange =
      isManual && hasPermission && previousOccurred && isNextState;

    return canChange;
  }

  canEditEventDate(event: any): boolean {
    if (!this.isEditModeEnabled) return false;
    const hasPermission = !!this.authService.loggedUser$.value?.editSOUnlimited;
    if (!hasPermission) return false;

    // Verificar que el evento realmente existe en serviceOrder.events
    // Si existe, se puede editar su fecha independientemente de si es siguiente o anterior
    const existingEvent = (this.serviceOrder?.events || []).find(
      (e: any) => e.eventTypeId === event.id,
    );

    // Solo permitir editar si el evento existe
    return !!existingEvent;
  }

  openStateChangeConfirmation(event: any): void {
    this.pendingEvent = event;
    this.confirmationModalConfig = {
      title: 'Cambiar estado',
      message: '¿Deseas cambiar a este estado?',
      confirmText: 'Cambiar',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: false,
      showTextarea: false,
      showDatePicker: true,
      dateValue: this.eventDate,
      dateRequired: true,
    };
    this.confirmationModal.open();
  }

  handleEventClick(event: any): void {
    if (!this.isEditModeEnabled) {
      return;
    }

    // Solo permitir cambiar al estado si es un evento futuro (no ha ocurrido)
    if (this.canChangeToState(event)) {
      this.openStateChangeConfirmation(event);
      return;
    }

    // No hacer nada para eventos pasados/actuales
    // Los eventos que ya ocurrieron no se pueden modificar
  }

  openEventDateEditConfirmation(event: any): void {
    this.pendingEvent = undefined;
    this.pendingEventForEdit = event;

    const existingEvent = (this.serviceOrder?.events || [])
      .filter((e: any) => e.eventTypeId === event.id)
      .sort((a: any, b: any) => b.id - a.id)[0];
    const currentDate = existingEvent
      ? new Date(existingEvent.dateTime)
      : new Date();

    this.confirmationModalConfig = {
      title: 'Editar fecha del evento',
      message: `¿Deseas editar la fecha del evento "${event.name}"?`,
      confirmText: 'Actualizar',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: false,
      showTextarea: false,
      showDatePicker: true,
      dateValue: currentDate,
      dateRequired: true,
    };
    this.confirmationModal.open();
  }

  onStateChangeConfirmed(data: { textValue?: string; dateValue?: Date }): void {
    this.confirmationModal.config.processing = true;

    if (data.dateValue) {
      this.eventDate = data.dateValue;
    }

    if (this.pendingEvent) {
      this.setState(this.pendingEvent);
    } else if (this.pendingEventForEdit) {
      this.editEventDate(this.pendingEventForEdit, data.dateValue!);
    }
  }

  setState(event: any): void {
    const payload: EventCreate = {
      eventTypeId: event.id,
      serviceOrderId: this.serviceOrder.id,
      dateTime: this.eventDate.toISOString(),
      isActive: true,
    };
    this.flowEventService.createEvent(payload).subscribe({
      next: (rsp) => {
        // Actualizar el estado y los eventos
        this.serviceOrder.state = event.id.toString();
        this.serviceOrder.events = [
          ...(this.serviceOrder.events || []),
          rsp.data,
        ];

        // Crear nueva referencia del objeto para forzar detección de cambios
        this.serviceOrder = { ...this.serviceOrder };

        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
        this.cdr.detectChanges();
        this.showSuccessToast(`Estado cambiado a "${event.name}"`);
      },
      error: (e) => {
        console.error(e);
        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
        this.cdr.detectChanges();
        this.showErrorToast('Error al cambiar el estado');
      },
    });
  }

  editEventDate(eventType: any, newDate: Date): void {
    const existingEvent = (this.serviceOrder?.events || [])
      .filter((e: any) => e.eventTypeId === eventType.id)
      .sort((a: any, b: any) => b.id - a.id)[0];

    if (!existingEvent) {
      this.showErrorToast('No se encontró el evento para editar');
      this.confirmationModal.config.processing = false;
      this.confirmationModal.forceClose();
      return;
    }

    const payload: any = {
      id: existingEvent.id,
      dateTime: newDate.toISOString(),
    };

    this.flowEventService.patchEvent(payload).subscribe({
      next: (rsp) => {
        const eventIndex = (this.serviceOrder.events || []).findIndex(
          (e: any) => e.id === existingEvent.id,
        );
        if (eventIndex !== -1) {
          this.serviceOrder.events![eventIndex] = {
            ...existingEvent,
            dateTime: newDate.toISOString(),
          };
        }

        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
        this.cdr.detectChanges();
        this.showSuccessToast(
          `Fecha del evento "${eventType.name}" actualizada correctamente`,
        );
      },
      error: (e) => {
        console.error(e);
        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
        this.cdr.detectChanges();
        this.showErrorToast('Error al actualizar la fecha del evento');
      },
    });
  }

  showSuccessToast(message: string): void {
    this.toastConfig = {
      icon: 'check_circle',
      iconColor: '#6CDA75',
      content: message,
      showUndo: false,
    };
    this.showNotification(message);
  }

  showErrorToast(message: string): void {
    this.toastConfig = {
      icon: 'dangerous',
      iconColor: '#CB2A2F',
      content: message,
      showUndo: false,
    };
    this.showNotification(message);
  }

  // Cambiar la etapa de la oportunidad usando el endpoint específico
  changeStage(stage: any): void {
    // Solo permitir cambio de etapa si está en modo edición
    if (!this.isEditModeEnabled) {
      return;
    }

    const stageId = stage.id;
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;

    // Verificar si el valor cambió
    const backupValue = this.opportunity?.stageId;
    if (backupValue === stageId || backupValue == stageId) {
      return; // No hay cambio
    }

    if (!opportunityId) {
      console.error('No se pudo identificar el service order');
      return;
    }

    // Guardar el valor anterior para poder revertir si es necesario
    const path = 'stageId';
    if (!this.backupFieldValues[path]) {
      this.backupFieldValues[path] = backupValue;
    }

    // Actualizar el objeto local (optimistic update)
    if (this.opportunity) {
      this.opportunity.stageId = stageId;
    }

    // Usar el endpoint específico según si es lead u oportunidad
    const changeStageObservable = this.isLead
      ? this.opportunityService.changeLeadStage(opportunityId, stageId)
      : this.opportunityService.changeOpportunityStage(opportunityId, stageId);

    changeStageObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response: any) => {
        // Actualizar la oportunidad con la respuesta del backend
        if (response?.data) {
          const updatedOpportunity =
            this.opportunitiesUtilsService.mapOpportunityData(response.data);
          if (updatedOpportunity) {
            // Preservar datos locales que no vienen del backend
            this.opportunity = {
              ...this.opportunity,
              ...updatedOpportunity,
              documents: this.opportunity?.documents || [],
              chat: this.opportunity?.chat,
            };
            // Actualizar isLost después de actualizar la oportunidad
            this.updateIsLost();
            // Actualizar isWon después de actualizar la oportunidad
            this.updateIsWon();
            // Actualizar canCreateQuote después de actualizar la oportunidad
            this.updateCanCreateQuote();
            // Actualizar el nombre de la etapa actual
            this.updateCurrentStageName();
            // Emitir evento para actualizar el componente padre
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
          }
        } else if (response?.id) {
          const updatedOpportunity =
            this.opportunitiesUtilsService.mapOpportunityData(response);
          if (updatedOpportunity) {
            this.opportunity = {
              ...this.opportunity,
              ...updatedOpportunity,
              documents: this.opportunity?.documents || [],
              chat: this.opportunity?.chat,
            };
            // Actualizar isLost después de actualizar la oportunidad
            this.updateIsLost();
            // Actualizar isWon después de actualizar la oportunidad
            this.updateIsWon();
            // Actualizar canCreateQuote después de actualizar la oportunidad
            this.updateCanCreateQuote();
            // Actualizar el nombre de la etapa actual
            this.updateCurrentStageName();
            // Emitir evento para actualizar el componente padre
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
          }
        } else {
          // Fallback: actualizar solo el campo específico
          if (this.opportunity) {
            this.opportunity.stageId = stageId;
            // Actualizar canCreateQuote después de actualizar la etapa
            this.updateCanCreateQuote();
            // Actualizar el nombre de la etapa actual
            this.updateCurrentStageName();
            // Emitir evento para actualizar el componente padre
            this.updateEvent.emit(this.opportunity);
            this.cdr.detectChanges();
          }
        }
      },
      error: (error: any) => {
        console.error('Error cambiando etapa:', error);
        // Revertir el cambio visualmente si es necesario
        if (this.backupFieldValues[path] !== undefined && this.opportunity) {
          this.opportunity.stageId = this.backupFieldValues[path];
          this.cdr.detectChanges();
        }
      },
    });
  }

  // Change opportunity (navigation similar to service orders)
  changeOpportunity(isNext: boolean, isPrev: boolean, id: number): void {
    this.changeOpportunityEvent.emit({ isNext, isPrev, id });
  }

  // Update computed properties
  updateComputedProperties(): void {
    // Update stages
    this.updateStagesForTeam();
    this.updateCurrentStageName();

    if (this.viewMode === 'budget') {
      // Update budget properties
      if (this.budget) {
        this.budgetName = this.budget.name || '-';
        const stageValue = this.budget.stage || 'Budget';
        this.currentBudgetStageValue = stageValue;
        const currentStage = this.budgetStages.find(
          (s) => s.value === stageValue,
        );
        this.currentBudgetStageName = currentStage?.name || 'Presupuesto';
        this.hasMultipleBudgets = (this.budgetList?.length || 0) > 1;
      }

      // También actualizar opportunityName cuando estamos en modo budget
      // para que el header muestre el nombre correcto de la oportunidad
      if (this.opportunity) {
        if (
          this.opportunity?.oportunidad &&
          this.opportunity.oportunidad !== '-'
        ) {
          this.opportunityName = this.opportunity.oportunidad;
        } else if (
          this.opportunity?.originalOpportunityName &&
          this.opportunity.originalOpportunityName !== '-'
        ) {
          this.opportunityName = this.opportunity.originalOpportunityName;
        } else {
          const contactName = this.getContactName();
          if (
            this.opportunity?.name &&
            this.opportunity.name !== contactName &&
            this.opportunity.name !== '-'
          ) {
            this.opportunityName = this.opportunity.name;
          } else {
            this.opportunityName = '-';
          }
        }

        // Current opportunity ID
        this.currentOpportunityId =
          this.opportunity?.id || this.opportunity?.originalId || 0;

        // Opportunity users
        this.opportunityUsers = this.getOpportunityUsers();
      }

      return;
    }

    if (!this.opportunity) return;

    // Opportunity name
    if (this.opportunity?.oportunidad && this.opportunity.oportunidad !== '-') {
      this.opportunityName = this.opportunity.oportunidad;
    } else if (
      this.opportunity?.originalOpportunityName &&
      this.opportunity.originalOpportunityName !== '-'
    ) {
      this.opportunityName = this.opportunity.originalOpportunityName;
    } else {
      const contactName = this.getContactName();
      if (
        this.opportunity?.name &&
        this.opportunity.name !== contactName &&
        this.opportunity.name !== '-'
      ) {
        this.opportunityName = this.opportunity.name;
      } else {
        this.opportunityName = '-';
      }
    }

    // Current opportunity ID
    this.currentOpportunityId =
      this.opportunity?.id || this.opportunity?.originalId || 0;

    // Opportunity users
    this.opportunityUsers = this.getOpportunityUsers();

    // Has multiple opportunities
    this.hasMultipleOpportunities =
      (this.nzData.opportunityList?.length || 0) > 1;
  }

  // Load budgets list (solo se llama al abrir el drawer)
  loadBudgets(): void {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) return;

    this.opportunityService
      .getSaleOrders({
        startRow: 0,
        endRow: 100,
        sortDirection: 'desc',
        sortProperty: 'budgetDate',
        leadId: opportunityId,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.budgetList = response?.data?.rows || [];
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading budgets:', error);
          this.budgetList = [];
        },
      });
  }

  // Open budget view (acepta ID o objeto completo)
  openBudgetView(budgetOrId: any): void {
    if (!budgetOrId) return;

    // Si es un ID, buscar o cargar el presupuesto completo
    if (typeof budgetOrId === 'number') {
      const budgetId = budgetOrId;

      // Primero buscar en la lista actual
      let budget = this.budgetList.find((b: any) => b.id === budgetId);

      if (!budget) {
        // Si no está en la lista, recargar la lista
        this.loadBudgets();

        // Esperar a que se carguen los presupuestos
        setTimeout(() => {
          budget = this.budgetList.find((b: any) => b.id === budgetId);
          if (budget) {
            this.setBudgetView(budget);
          } else {
            // Si aún no está, cargar directamente desde el backend
            this.loadBudgetById(budgetId);
          }
        }, 100);
        return;
      }

      this.setBudgetView(budget);
    } else {
      // Es un objeto completo
      this.setBudgetView(budgetOrId);
    }
  }

  // Método privado para establecer la vista de presupuesto
  private setBudgetView(budget: any): void {
    if (!budget) return;

    this.hasBudgetQuotationLines = false;
    // Asegurar que budgetList esté cargado
    if (this.budgetList.length === 0) {
      this.loadBudgets();
      // Esperar a que se carguen los presupuestos antes de continuar
      setTimeout(() => {
        this.setBudgetView(budget);
      }, 200);
      return;
    }

    // backup para poder cancelar sin persistir cambios locales
    this.budgetModeOpportunityBackup = this.opportunity
      ? JSON.parse(JSON.stringify(this.opportunity))
      : null;
    this.budgetBackup = budget ? JSON.parse(JSON.stringify(budget)) : null;

    this.viewMode = 'budget';
    this.budget = budget;

    // Encontrar el índice del presupuesto actual en la lista ya cargada
    this.currentBudgetIndex = this.budgetList.findIndex(
      (b: any) => b.id === budget.id,
    );
    if (this.currentBudgetIndex === -1) {
      // Si no está en la lista, agregarlo al principio
      this.budgetList.unshift(budget);
      this.currentBudgetIndex = 0;
    }

    // Actualizar todas las propiedades computadas (incluyendo opportunityName, budgetName, etc.)
    this.updateComputedProperties();

    // Forzar detección de cambios para actualizar el header y otros elementos
    this.cdr.detectChanges();

    // Actualizar la URL siempre, usando setTimeout si estamos inicializando
    // para asegurar que se actualice después de que el drawer esté completamente abierto
    if (this.isInitializing) {
      setTimeout(() => {
        this.updateUrlFromState();
      }, 150);
    } else {
      // Si no estamos inicializando, actualizar inmediatamente
      this.updateUrlFromState();
    }
  }

  // Cargar un presupuesto por ID desde el backend
  private loadBudgetById(budgetId: number): void {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) return;

    this.opportunityService
      .getSaleOrders({
        startRow: 0,
        endRow: 100,
        sortDirection: 'desc',
        sortProperty: 'budgetDate',
        leadId: opportunityId,
      })
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.budgetList = response?.data?.rows || [];
          const budget = this.budgetList.find((b: any) => b.id === budgetId);
          if (budget) {
            this.setBudgetView(budget);
          }
        },
        error: (error) => {
          console.error('Error loading budget:', error);
        },
      });
  }

  // Load budget (solo cambia el presupuesto actual, no hace peticiones)
  loadBudget(budget: any): void {
    if (!budget) return;
    // Usar setBudgetView para mantener consistencia
    this.setBudgetView(budget);
  }

  // Close budget view (solo cambia la vista, no cierra el drawer)
  closeBudgetView(): void {
    // Limpiar estados de edición si hay alguno activo
    if (this.isBudgetEditModeEnabled) {
      this.budgetEditModeAction = 'cancel';
      this.cdr.detectChanges();

      if (this.budgetBackupForEdit) {
        this.budget = JSON.parse(JSON.stringify(this.budgetBackupForEdit));
      }

      this.budgetEditModeAction = 'none';
      this.isBudgetEditModeEnabled = false;
      this.budgetBackupForEdit = null;
    }

    // restaurar backups si existen (solo localmente, sin enviar al backend)
    if (this.budgetModeOpportunityBackup) {
      this.opportunity = JSON.parse(
        JSON.stringify(this.budgetModeOpportunityBackup),
      );
    }
    if (this.budgetBackup) {
      this.budget = JSON.parse(JSON.stringify(this.budgetBackup));
    }

    // NO enviar los valores restaurados al backend al cerrar la vista
    // Solo restaurar localmente para mostrar la vista del service order

    this.budgetModeOpportunityBackup = null;
    this.budgetBackup = null;

    // Cambiar el viewMode antes de actualizar propiedades
    this.viewMode = this.isLead ? 'lead' : 'opportunity';
    this.budget = null;
    // NO limpiar budgetList completamente, mantenerlo para que los tabs funcionen
    // this.budgetList = [];
    this.currentBudgetIndex = 0;

    // Actualizar propiedades computadas para reflejar el cambio de vista
    this.updateComputedProperties();

    // Forzar detección de cambios para asegurar que los valores restaurados se reflejen
    this.cdr.detectChanges();

    // Actualizar la URL
    this.updateUrlFromState();
  }

  // Open budget preview - descarga el PDF como attachment
  openBudgetPreview(): void {
    if (!this.budget?.id || !this.hasBudgetQuotationLines) {
      console.error('No hay presupuesto seleccionado');
      return;
    }

    const saleOrderIdNum = Number(this.budget.id);

    // Usar el método que descarga el PDF como blob desde /preview
    this.opportunityService
      .generateSaleOrderPdfPreview(saleOrderIdNum)
      .subscribe({
        next: (blob: Blob) => {
          // Crear objeto URL para el Blob
          const url = window.URL.createObjectURL(blob);

          // Crear elemento <a> invisible para la descarga
          const a = document.createElement('a');
          a.href = url;

          // Establecer el nombre del archivo
          const fileName = this.budgetName
            ? `${this.budgetName
                .replace(/\//g, '-')  // Reemplazar / por -
                .replace(/:/g, '.')   // Reemplazar : por . (para la hora quede legible como 11.58)
                .replace(/[^\w\s.-]/gi, '')  // Eliminar otros caracteres especiales (mantener punto y guion)
                .replace(/\s+/g, '_')  // Reemplazar espacios por _
                .replace(/\.{2,}/g, '.')  // Limpiar puntos dobles o más
                .replace(/_\._/g, '_')  // Limpiar patrones _._
                .replace(/\._/g, '_')   // Limpiar patrones ._
                .replace(/_\./g, '_')   // Limpiar patrones _.
              }.pdf`
            : `presupuesto_${this.budget.id}.pdf`;
          a.download = fileName;

          // Disparar la descarga
          document.body.appendChild(a);
          a.click();

          // Limpiar recursos
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        },
        error: (err) => {
          console.error('Error al descargar el PDF del presupuesto:', err);
        },
      });
  }

  // Generate budget PDF version - stores an immutable PDF; it does not open it
  generateBudgetVersion(): void {
    if (this.generatingVersion) {
      return;
    }
    if (!this.budget?.id || !canGenerateBudgetVersion(this.budget, this.hasBudgetQuotationLines)) {
      return;
    }

    const pastExpiration = getPastBudgetExpiration(this.budget.expirationDate);
    if (pastExpiration) {
      const confirmation = buildPastExpirationConfirmation(pastExpiration);
      this.modalService.confirm({
        nzTitle: confirmation.title,
        nzContent: confirmation.content,
        nzOkText: confirmation.okText,
        nzCancelText: confirmation.cancelText,
        nzOnOk: () => this.openIssueCurrencyPicker(),
        // Same entry point as the "Editar presupuesto" button, which is only shown with edit permissions.
        nzOnCancel: () => {
          if (this.nzData?.editPermissions) {
            this.startEditModeBudget();
          }
        },
      });
      return;
    }

    this.openIssueCurrencyPicker();
  }

  private openIssueCurrencyPicker(): void {
    const data: BudgetIssueCurrencyPickerData = {
      currencies: this.globalValuesService.currencies$.value,
      budgetCurrencyId: this.budget?.currencyId,
    };
    openBudgetIssueCurrencyPicker(this.modalService, data, (issueCurrencyId) =>
      this.requestBudgetVersion(issueCurrencyId),
    );
  }

  private requestBudgetVersion(issueCurrencyId?: number): void {
    if (this.generatingVersion || !this.budget?.id) {
      return;
    }

    const selectedIso =
      this.globalValuesService.currencies$.value.find((currency) => currency.id === issueCurrencyId)?.isoCode ?? null;

    this.generatingVersion = true;
    this.cdr.detectChanges();

    this.opportunityService
      .generateSaleOrderPdfVersion(Number(this.budget.id), undefined, issueCurrencyId)
      .pipe(
        take(1),
        finalize(() => {
          this.generatingVersion = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response) => {
          this.showNotification(formatBudgetVersionGeneratedMessage(response));
          if (wasIssueCurrencyIgnored(response, issueCurrencyId !== undefined)) {
            this.showErrorNotification(buildIssueCurrencyIgnoredMessage());
          }
          this.pdfVersionsRefreshKey++;
        },
        error: (err) => {
          const { message, refreshList } = mapBudgetVersionGenerationError(err, selectedIso);
          this.showErrorNotification(message);
          if (refreshList) {
            this.pdfVersionsRefreshKey++;
          }
        },
      });
  }

  // Change budget (navegación entre presupuestos)
  changeBudget(isNext: boolean, isPrev: boolean, budgetId?: number): void {
    // Si budgetList está vacío, cargarlo primero
    if (this.budgetList.length === 0) {
      this.loadBudgets();
      // Esperar a que se carguen los presupuestos
      setTimeout(() => {
        this.changeBudget(isNext, isPrev, budgetId);
      }, 200);
      return;
    }

    if (budgetId) {
      const budget = this.budgetList.find((b: any) => b.id === budgetId);
      if (budget) {
        this.setBudgetView(budget);
      }
      return;
    }

    if (isNext && this.currentBudgetIndex < this.budgetList.length - 1) {
      this.currentBudgetIndex++;
      this.setBudgetView(this.budgetList[this.currentBudgetIndex]);
    } else if (isPrev && this.currentBudgetIndex > 0) {
      this.currentBudgetIndex--;
      this.setBudgetView(this.budgetList[this.currentBudgetIndex]);
    }
  }

  /**
   * Inicializa el viewMode basado en los parámetros de la ruta
   */
  private initializeViewModeFromRoute(): void {
    const routeParams = this.route.snapshot.params;
    const queryParams = this.route.snapshot.queryParams;
    const urlSegments = this.route.snapshot.url.map((segment) => segment.path);
    const currentUrl = this.router.url;

    // Si hay un budgetId en la ruta o en los query params, mostrar vista de presupuesto
    if (routeParams['budgetId'] || queryParams['budget']) {
      this.viewMode = 'budget';
      // El presupuesto se cargará después de que se carguen los presupuestos
      // Se cargará en loadSpecificBudget después de que se carguen los presupuestos
      return;
    }

    // Si es un lead en la ruta específica (/opportunities/lead/:id)
    if (routeParams['id'] && urlSegments.includes('lead')) {
      this.isLead = true;
      this.viewMode = 'lead';
    }
    // Si estamos en la ruta de leads (/opportunities/leads) o si ya se detectó que es lead
    else if (
      this.isLead ||
      currentUrl.includes('/leads') ||
      this.nzData.maestroName === 'Leads'
    ) {
      // Asegurar que isLead esté establecido correctamente
      if (!this.isLead) {
        this.isLead = true;
      }
      this.viewMode = 'lead';
    }
    // Por defecto, es una oportunidad
    else {
      this.viewMode = 'opportunity';
    }
  }

  /**
   * Actualiza la URL basándose en el estado actual del drawer
   * Para Service Orders, no necesitamos navegación compleja como en oportunidades
   */
  private updateUrlFromState(): void {
    // Para Service Orders, no realizamos navegación de URL compleja
    // El drawer se mantiene abierto sin cambiar la ruta
    return;
  }
  private loadSpecificBudget(budgetId: number): void {
    if (!this.budgetList || this.budgetList.length === 0) {
      // Si no hay presupuestos cargados, cargarlos primero
      const opportunityId =
        this.opportunity?.id || this.opportunity?.originalId;
      if (!opportunityId) return;

      this.opportunityService
        .getSaleOrders({
          startRow: 0,
          endRow: 100,
          sortDirection: 'desc',
          sortProperty: 'budgetDate',
          leadId: opportunityId,
        })
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            this.budgetList = response?.data?.rows || [];
            const budget = this.budgetList.find((b: any) => b.id === budgetId);
            if (budget) {
              this.openBudgetView(budget);
            }
          },
          error: (error) => {
            console.error('Error loading budgets:', error);
          },
        });
    } else {
      const budget = this.budgetList.find((b: any) => b.id === budgetId);
      if (budget) {
        this.openBudgetView(budget);
      }
    }
  }

  // Handle field update from child components
  onFieldUpdate(data: { path: string; value: any; previousValue?: any }): void {
    // En modo edición, actualizar el serviceOrder localmente pero no guardar automáticamente
    if (this.isEditModeEnabled) {
      // Guardar backup para tags si viene en el evento (para poder revertir)
      if (data.path === 'tags' && data.previousValue !== undefined) {
        this.backupFieldValues[data.path] = data.previousValue;
      }

      // Actualizar el serviceOrder con el nuevo valor para acumular cambios localmente
      if (this.serviceOrder && data.path) {
        this.serviceOrder[data.path] = data.value;
      }

      // No llamar patchField - los cambios se guardarán solo al presionar "Guardar"
      return;
    }

    // Si no está en modo edición, guardar automáticamente (comportamiento anterior)
    // Guardar backup para tags si viene en el evento
    if (data.path === 'tags' && data.previousValue !== undefined) {
      this.backupFieldValues[data.path] = data.previousValue;
    }
    // Delegar al método patchField existente y suscribirse al resultado
    this.patchField(data.path, data.value).subscribe();
  }

  // Handle field update from budget component
  onBudgetFieldUpdate(data: {
    path: string;
    value: any;
    previousValue?: any;
  }): void {
    // En modo edición de presupuesto, no guardar automáticamente - solo acumular cambios locales
    if (this.isBudgetEditModeEnabled) {
      // Los cambios se guardarán solo al presionar "Guardar"
      return;
    }

    // Si no está en modo edición, guardar automáticamente (comportamiento anterior)
    // TODO: Implementar guardado automático de presupuesto si es necesario
  }

  // Handle budget click from order details content
  onBudgetClick(budget: any): void {
    // TODO: Implementar navegación o apertura del presupuesto seleccionado
  }

  // Start edit mode for budget
  startEditModeBudget(): void {
    if (this.isBudgetEditModeEnabled) return;

    // Crear backup del presupuesto
    this.budgetBackupForEdit = this.budget
      ? JSON.parse(JSON.stringify(this.budget))
      : null;

    this.isBudgetEditModeEnabled = true;
    this.cdr.detectChanges();
  }

  // Save edit mode for budget
  async saveEditModeBudget(): Promise<void> {
    if (!this.budget || !this.budget.id) {
      console.warn('No hay presupuesto para guardar');
      return;
    }

    // Notificar al componente hijo que se va a guardar
    this.budgetEditModeAction = 'save';
    this.cdr.detectChanges();

    // Construir el payload con los datos del presupuesto actual
    const budgetId = this.budget.id;
    const payload = {
      id: budgetId,
      name: this.budget.name || '',
      driveUrl: this.budget.driveUrl || '',
      isActive:
        this.budget.isActive !== undefined ? this.budget.isActive : true,
      leadId:
        this.budget.leadId ||
        this.opportunity?.id ||
        this.opportunity?.originalId,
      teamId: this.budget.teamId || this.opportunity?.teamId,
      currencyId: this.budget.currencyId || 1,
      partnerId: this.budget.partnerId || null,
      expirationDate: this.budget.expirationDate
        ? typeof this.budget.expirationDate === 'string'
          ? this.budget.expirationDate
          : new Date(this.budget.expirationDate).toISOString()
        : null,
      budgetDate: this.budget.budgetDate
        ? typeof this.budget.budgetDate === 'string'
          ? this.budget.budgetDate
          : new Date(this.budget.budgetDate).toISOString()
        : null,
      budgetTemplateId: this.budget.budgetTemplateId || null,
      priceListId: this.budget.priceListId || null,
      paymentConditionsId: this.budget.paymentConditionsId || null,
      // Incluir líneas de presupuesto si existen
      quotationLines: this.budget.quotationLines || [],
      // Las líneas de presupuesto (budgetLines) se manejan por separado en /api/budgetline
      // No se incluyen en el payload del presupuesto
    };

    this.savingBudget = true;

    // Actualizar presupuesto usando PUT (similar a updateOpportunity)
    this.opportunityService
      .updateSaleOrder(budgetId, payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.savingBudget = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            // Actualizar localmente el presupuesto
            this.budget = {
              ...this.budget,
              ...response.data,
            };

            // Actualizar también en la lista
            const index = this.budgetList.findIndex(
              (b: any) => b.id === budgetId,
            );
            if (index !== -1) {
              this.budgetList[index] = { ...this.budget };
            } else {
              // Si no está en la lista, agregarlo
              this.budgetList.unshift(this.budget);
            }

            this.budgetEditModeAction = 'none';
            this.isBudgetEditModeEnabled = false;
            this.budgetBackupForEdit = null;

            // Actualizar propiedades computadas (esto actualizará budgetName, etc.)
            this.updateComputedProperties();

            // Mostrar notificación de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Presupuesto actualizado exitosamente.',
              showUndo: false,
            };
            this.notRef = this.notificationService.create(
              'blank',
              '',
              this.notificationTmpl,
              { nzPlacement: 'bottomRight' },
            );

            // Actualizar la URL si es necesario
            if (!this.isInitializing) {
              this.updateUrlFromState();
            }

            // Enviar mensaje al chat y actualizar referencias
            //this.sendBudgetSavedMessage();

            // Forzar detección de cambios para que el componente hijo reciba el budget actualizado
            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          console.error('Error al guardar presupuesto:', error);
          this.budgetEditModeAction = 'none';

          // Mostrar error
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content:
              error.error?.message || 'Error al actualizar el presupuesto.',
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        },
      });
  }

  // Cancel edit mode for budget
  confirmCancelEditModeBudget(): void {
    this.modalService.confirm({
      nzTitle: '¿Cancelar cambios?',
      nzContent:
        '¿Estás seguro de que deseas cancelar los cambios realizados? Se perderán todos los cambios no guardados.',
      nzOkText: 'Sí, cancelar',
      nzOkDanger: true,
      nzCancelText: 'No',
      nzOnOk: () => {
        this.cancelEditModeBudget();
      },
    });
  }

  // Cancel edit mode for budget (without confirmation)
  private cancelEditModeBudget(): void {
    // Restaurar el presupuesto desde el backup
    if (this.budgetBackupForEdit) {
      this.budget = JSON.parse(JSON.stringify(this.budgetBackupForEdit));
    }

    this.budgetEditModeAction = 'none';
    this.isBudgetEditModeEnabled = false;
    this.budgetBackupForEdit = null;

    // Actualizar la URL solo si estamos en modo budget y tenemos un budget
    // para mantener la vista de detalles del presupuesto
    if (!this.isInitializing && this.viewMode === 'budget' && this.budget?.id) {
      const opportunityId =
        this.opportunity?.id || this.opportunity?.originalId;
      if (opportunityId) {
        // Usar query params para mantener el drawer abierto con el presupuesto
        this.router
          .navigate([], {
            relativeTo: this.route,
            queryParams: {
              opportunity: opportunityId,
              budget: this.budget.id,
            },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          })
          .catch((error) => {
            console.warn(
              'Error al actualizar query params de presupuesto al cancelar:',
              error,
            );
          });
      }
    }

    this.cdr.detectChanges();
  }

  // Budget actions
  cancelBudget(): void {
    if (!this.budget?.id) return;
    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) return;

    this.cancelingBudget = true;
    this.opportunityService
      .cancelSaleOrder(this.budget.id, leadId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.cancelingBudget = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            // Actualizar el presupuesto con los datos de la respuesta
            this.budget = { ...this.budget, ...response.data };
            // Actualizar en la lista también
            const index = this.budgetList.findIndex(
              (b: any) => b.id === this.budget.id,
            );
            if (index !== -1) {
              this.budgetList[index] = { ...this.budget };
            }
            // Actualizar propiedades computadas
            this.updateComputedProperties();
            this.cdr.detectChanges();

            // Mostrar notificación de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Presupuesto cancelado correctamente.',
              showUndo: false,
            };
            this.notRef = this.notificationService.create(
              'blank',
              '',
              this.notificationTmpl,
              { nzPlacement: 'bottomRight' },
            );
          }
        },
        error: (error: any) => {
          console.error('Error cancelando presupuesto:', error);
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content:
              error.error?.message || 'Error al cancelar el presupuesto.',
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        },
      });
  }

  recoverBudget(): void {
    if (!this.budget?.id) return;
    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) return;

    this.recoveringBudget = true;
    this.opportunityService
      .recoverSaleOrder(this.budget.id, leadId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.recoveringBudget = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            // Actualizar el presupuesto con los datos de la respuesta
            this.budget = { ...this.budget, ...response.data };
            // Actualizar en la lista también
            const index = this.budgetList.findIndex(
              (b: any) => b.id === this.budget.id,
            );
            if (index !== -1) {
              this.budgetList[index] = { ...this.budget };
            }
            // Actualizar propiedades computadas
            this.updateComputedProperties();
            this.cdr.detectChanges();

            // Mostrar notificación de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Presupuesto recuperado correctamente.',
              showUndo: false,
            };
            this.notRef = this.notificationService.create(
              'blank',
              '',
              this.notificationTmpl,
              { nzPlacement: 'bottomRight' },
            );
          }
        },
        error: (error: any) => {
          console.error('Error recuperando presupuesto:', error);
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content:
              error.error?.message || 'Error al recuperar el presupuesto.',
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        },
      });
  }

  requestApproval(): void {
    if (!this.budget?.id) return;
    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) return;

    this.requestingApproval = true;
    this.opportunityService
      .setApproveStatusSaleOrder(this.budget.id, leadId, true)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.requestingApproval = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            // Actualizar el presupuesto con los datos de la respuesta
            this.budget = { ...this.budget, ...response.data };
            // Actualizar en la lista también
            const index = this.budgetList.findIndex(
              (b: any) => b.id === this.budget.id,
            );
            if (index !== -1) {
              this.budgetList[index] = { ...this.budget };
            }
            // Actualizar propiedades computadas
            this.updateComputedProperties();
            this.cdr.detectChanges();

            // Mostrar notificación de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Aprobación solicitada correctamente.',
              showUndo: false,
            };
            this.notRef = this.notificationService.create(
              'blank',
              '',
              this.notificationTmpl,
              { nzPlacement: 'bottomRight' },
            );
          }
        },
        error: (error: any) => {
          console.error('Error solicitando aprobación:', error);
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content:
              error.error?.message ||
              'Error al solicitar la aprobación del presupuesto.',
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        },
      });
  }

  confirmBudget(): void {
    if (!this.budget?.id) return;
    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) return;

    this.confirmingBudget = true;
    this.opportunityService
      .confirmSaleOrder(this.budget.id, leadId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.confirmingBudget = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            // Actualizar el presupuesto con los datos de la respuesta
            this.budget = { ...this.budget, ...response.data };
            // Actualizar en la lista también
            const index = this.budgetList.findIndex(
              (b: any) => b.id === this.budget.id,
            );
            if (index !== -1) {
              this.budgetList[index] = { ...this.budget };
            }
            // Actualizar propiedades computadas
            this.updateComputedProperties();
            this.cdr.detectChanges();

            // Mostrar notificación de éxito
            this.toastConfig = {
              icon: 'check_circle',
              iconColor: '#6CDA75',
              content: 'Presupuesto adoptado correctamente.',
              showUndo: false,
            };
            this.notRef = this.notificationService.create(
              'blank',
              '',
              this.notificationTmpl,
              { nzPlacement: 'bottomRight' },
            );
          }
        },
        error: (error: any) => {
          console.error('Error adoptando presupuesto:', error);
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content: error.error?.message || 'Error al adoptar el presupuesto.',
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        },
      });
  }

  adoptBudget(): void {
    this.executeAdoptBudget();
  }

  private executeAdoptBudget(updateLinkedSaleOrderLines?: boolean): void {
    if (!this.budget?.id) return;
    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) return;

    this.adoptingBudget = true;
    this.opportunityService
      .adoptSaleOrder(this.budget.id, leadId, updateLinkedSaleOrderLines)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.adoptingBudget = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          this.applyAdoptBudgetResponse(response);
        },
        error: (error: any) => {
          if (this.isAdoptBudgetConfirmationRequired(error)) {
            this.openAdoptBudgetConfirmation(error);
            return;
          }

          console.error('Error adoptando presupuesto:', error);
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content: error.error?.message || 'Error al adoptar el presupuesto.',
            showUndo: false,
          };
          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );
        },
      });
  }

  private applyAdoptBudgetResponse(response: any): void {
    const saleOrder = response?.data?.saleOrder || response?.data;
    if (!saleOrder) return;

    this.budget = { ...this.budget, ...saleOrder };
    const index = this.budgetList.findIndex(
      (b: any) => b.id === this.budget.id,
    );
    if (index !== -1) {
      this.budgetList[index] = { ...this.budget };
    }
    this.updateComputedProperties();
    this.cdr.detectChanges();

    this.toastConfig = {
      icon: 'check_circle',
      iconColor: '#6CDA75',
      content: 'Presupuesto adoptado correctamente.',
      showUndo: false,
    };
    this.notRef = this.notificationService.create(
      'blank',
      '',
      this.notificationTmpl,
      { nzPlacement: 'bottomRight' },
    );
  }

  private isAdoptBudgetConfirmationRequired(error: any): boolean {
    return error?.status === 409 && error?.error?.data?.requiresConfirmation === true;
  }

  private openAdoptBudgetConfirmation(error: any): void {
    const modifiedCount = error?.error?.data?.modifiedLinkedLinesCount || 0;
    this.modalService.confirm({
      nzTitle: 'Hay lineas del pedido con cambios',
      nzContent:
        `Se detectaron ${modifiedCount} linea(s) vinculada(s) que cambiaron respecto del presupuesto. ` +
        'Queres actualizar esas lineas existentes o mantenerlas como estan y adoptar solo las lineas directas?',
      nzOkText: 'Actualizar lineas',
      nzCancelText: 'Mantener actuales',
      nzOnOk: () => this.executeAdoptBudget(true),
      nzOnCancel: () => this.executeAdoptBudget(false),
    });
  }

  // Get users/participants for the opportunity (for avatar group)
  getOpportunityUsers(): any[] {
    const users: any[] = [];

    // Agregar el comercial si existe (objeto o por ID)
    let commercialUser = null;
    if (this.opportunity?.comercialUser) {
      commercialUser = {
        id: this.opportunity.comercialUser.id,
        name: this.opportunity.comercialUser.name,
        surName: this.opportunity.comercialUser.surName,
        avatar: this.opportunity.comercialUser.avatar,
      };
    } else if (this.opportunity?.userId) {
      const userList = this.globalValuesService.users$.value || [];
      const user = userList.find((u: any) => u.id === this.opportunity.userId);
      if (user?.partner) {
        commercialUser = {
          id: user.partner.id,
          name: user.partner.name,
          surName: user.partner.surName,
          avatar: user.partner.avatar,
        };
      }
    }

    if (commercialUser) {
      users.push(commercialUser);
    }

    // Agregar el contacto si existe y es diferente del comercial
    let contactPartner = null;
    if (this.opportunity?.contactPartner) {
      contactPartner = {
        id: this.opportunity.contactPartner.id,
        name: this.opportunity.contactPartner.name,
        surName: this.opportunity.contactPartner.surName,
        avatar: this.opportunity.contactPartner.avatar,
      };
    } else if (this.opportunity?.partnerId) {
      const partner = this.globalValuesService.partnerlist?.find(
        (p) => p.id === this.opportunity.partnerId,
      );
      if (partner) {
        contactPartner = {
          id: partner.id,
          name: partner.name,
          surName: partner.surName,
          avatar: partner.avatar,
        };
      }
    }

    if (contactPartner && contactPartner.id !== commercialUser?.id) {
      users.push(contactPartner);
    }

    // Aquí se pueden agregar más usuarios si la oportunidad tiene un array de participantes
    if (
      this.opportunity?.participants &&
      Array.isArray(this.opportunity.participants)
    ) {
      this.opportunity.participants.forEach((participant: any) => {
        if (!users.find((u) => u.id === participant.id)) {
          users.push(participant);
        }
      });
    }

    return users;
  }

  // Abrir modal para marcar como perdido
  markAsLost(): void {
    // Resetear el formulario
    this.lostForm.reset();

    this.markAsLostModalRef = this.modalService.create({
      nzTitle: undefined,
      nzContent: this.markAsLostModalTmpl,
      nzFooter: null,
      nzClosable: false,
      nzWidth: 518,
      nzCentered: true,
    });
  }

  // Confirmar y ejecutar la acción de marcar como perdido
  confirmMarkAsLost(): void {
    if (this.lostForm.invalid) {
      return;
    }

    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) {
      console.warn('No se encontró el ID del service order');
      return;
    }

    const formValue = this.lostForm.value;
    this.markingAsLost = true;

    // Cerrar el modal
    if (this.markAsLostModalRef) {
      this.markAsLostModalRef.close();
      this.markAsLostModalRef = null;
    }

    this.opportunityService
      .markAsLost(opportunityId, formValue.reason, formValue.lostNote)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.markingAsLost = false;
        }),
      )
      .subscribe({
        next: (response: PostResponse) => {
          // Mostrar notificación de éxito
          this.toastConfig.icon = 'check_circle';
          this.toastConfig.iconColor = '#6CDA75';
          this.toastConfig.content = this.isLead
            ? 'El lead ha sido marcado como perdido.'
            : 'La oportunidad ha sido marcada como perdida.';
          this.toastConfig.showUndo = false;
          this.notRef = this.notificationService.create(
            '',
            '',
            this.notificationTmpl,
            {
              nzPlacement: 'bottomRight',
              nzDuration: 3000,
            },
          );

          // Actualizar la oportunidad con la respuesta del backend si está disponible
          if (response?.data) {
            const updatedOpportunity =
              this.opportunitiesUtilsService.mapOpportunityData(response.data);
            if (updatedOpportunity) {
              this.opportunity = {
                ...this.opportunity,
                ...updatedOpportunity,
                documents: this.opportunity?.documents || [],
                chat: this.opportunity?.chat,
              };
              // Actualizar isLost después de actualizar la oportunidad
              this.updateIsLost();
              // Actualizar isWon después de actualizar la oportunidad
              this.updateIsWon();
              // Actualizar canCreateQuote después de actualizar la oportunidad
              this.updateCanCreateQuote();
              // Emitir evento para actualizar el componente padre
              this.updateEvent.emit(this.opportunity);
              this.cdr.detectChanges();
            }
          }
        },
        error: (error) => {
          console.error('Error al marcar como perdido:', error);
          this.toastConfig.icon = 'error';
          this.toastConfig.iconColor = '#FF4D4F';
          this.toastConfig.content = this.isLead
            ? 'Error al marcar el lead como perdido.'
            : 'Error al marcar la oportunidad como perdida.';
          this.toastConfig.showUndo = false;
          this.notRef = this.notificationService.create(
            '',
            '',
            this.notificationTmpl,
            {
              nzPlacement: 'bottomRight',
              nzDuration: 3000,
            },
          );
        },
      });
  }

  // Cancelar el modal de marcar como perdido
  cancelMarkAsLost(): void {
    if (this.markAsLostModalRef) {
      this.markAsLostModalRef.close();
      this.markAsLostModalRef = null;
    }
  }

  // Restaurar lead/oportunidad
  recoverLead(): void {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) {
      console.warn('No se encontró el ID del service order');
      return;
    }

    this.recoveringLead = true;
    this.opportunityService
      .recoverLead(opportunityId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.recoveringLead = false;
        }),
      )
      .subscribe({
        next: (response: PostResponse) => {
          // Mostrar notificación de éxito
          this.toastConfig.icon = 'check_circle';
          this.toastConfig.iconColor = '#6CDA75';
          this.toastConfig.content = this.isLead
            ? 'El lead ha sido restaurado.'
            : 'La oportunidad ha sido restaurada.';
          this.toastConfig.showUndo = false;
          this.notRef = this.notificationService.create(
            '',
            '',
            this.notificationTmpl,
            {
              nzPlacement: 'bottomRight',
              nzDuration: 3000,
            },
          );

          // Actualizar la oportunidad con la respuesta del backend si está disponible
          if (response?.data) {
            const updatedOpportunity =
              this.opportunitiesUtilsService.mapOpportunityData(response.data);
            if (updatedOpportunity) {
              this.opportunity = {
                ...this.opportunity,
                ...updatedOpportunity,
                documents: this.opportunity?.documents || [],
                chat: this.opportunity?.chat,
              };
              // Actualizar isLost después de actualizar la oportunidad
              this.updateIsLost();
              // Actualizar isWon después de actualizar la oportunidad
              this.updateIsWon();
              // Actualizar canCreateQuote después de actualizar la oportunidad
              this.updateCanCreateQuote();
              // Emitir evento para actualizar el componente padre
              this.updateEvent.emit(this.opportunity);
              this.cdr.detectChanges();
            }
          }
        },
        error: (error) => {
          console.error('Error al restaurar:', error);
          this.toastConfig.icon = 'error';
          this.toastConfig.iconColor = '#FF4D4F';
          this.toastConfig.content = this.isLead
            ? 'Error al restaurar el lead.'
            : 'Error al restaurar la oportunidad.';
          this.toastConfig.showUndo = false;
          this.notRef = this.notificationService.create(
            '',
            '',
            this.notificationTmpl,
            {
              nzPlacement: 'bottomRight',
              nzDuration: 3000,
            },
          );
        },
      });
  }

  // Mark opportunity as won
  markAsWon(): void {
    const opportunityId = this.opportunity?.id || this.opportunity?.originalId;
    if (!opportunityId) {
      console.warn('No se encontró el ID de la oportunidad');
      return;
    }

    this.loading = true;
    this.opportunityService
      .markOpportunityAsWon(opportunityId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response: PostResponse) => {
          // Mostrar notificación de éxito
          this.toastConfig.icon = 'check_circle';
          this.toastConfig.iconColor = '#6CDA75';
          this.toastConfig.content =
            'La oportunidad ha sido marcada como ganada.';
          this.toastConfig.showUndo = false;
          this.notRef = this.notificationService.create(
            '',
            '',
            this.notificationTmpl,
            {
              nzPlacement: 'bottomRight',
              nzDuration: 3000,
            },
          );

          // Actualizar la oportunidad con la respuesta del backend si está disponible
          if (response?.data) {
            const updatedOpportunity =
              this.opportunitiesUtilsService.mapOpportunityData(response.data);
            if (updatedOpportunity) {
              // Actualizar específicamente el stageId desde la respuesta
              // La respuesta tiene data.stageId y data.stage con la información de la etapa
              const newStageId =
                response.data.stageId || response.data.stage?.id;

              this.opportunity = {
                ...this.opportunity,
                ...updatedOpportunity,
                // Asegurar que el stageId se actualice desde la respuesta
                stageId:
                  newStageId !== undefined
                    ? newStageId
                    : this.opportunity.stageId,
                documents: this.opportunity?.documents || [],
                chat: this.opportunity?.chat,
              };

              // Actualizar isWon después de marcar como ganada
              this.updateIsWon();
              // Actualizar canCreateQuote después de actualizar la etapa
              this.updateCanCreateQuote();
              //actualizar etapas
              this.updateCurrentStageName();
              // Emitir evento para actualizar el componente padre
              this.updateEvent.emit(this.opportunity);
              this.cdr.detectChanges();
            }
          }
        },
        error: (error) => {
          console.error('Error al marcar la oportunidad como ganada:', error);
          this.toastConfig.icon = 'error';
          this.toastConfig.iconColor = '#FF4D4F';
          this.toastConfig.content =
            'Error al marcar la oportunidad como ganada.';
          this.toastConfig.showUndo = false;
          this.notRef = this.notificationService.create(
            '',
            '',
            this.notificationTmpl,
            {
              nzPlacement: 'bottomRight',
              nzDuration: 3000,
            },
          );
          this.loading = false;
          this.cdr.detectChanges();
        },
      });
  }

  // Abrir drawer para registrar nota
  openRegisterNoteDrawer(): void {
    // TODO: Implementar drawer para registrar nota
    // Por ahora, mostrar notificación
    /*  this.notificationService.info(
      'Registrar nota',
      'La funcionalidad para registrar notas estará disponible próximamente.'

    ); */
  }

  // Cargar actividades del service order
  loadActivities(): void {
    // Usar el ID de la subtarea (serviceOrder) en lugar del ID del proyecto
    const entityId =
      this.opportunity?.id ||
      this.opportunity?.originalId ||
      this.serviceOrder?.id;
    if (!entityId) return;

    this.loadingActivities = true;

    // Usar el ID de la subtarea para filtrar las actividades específicas de esa subtarea
    const activityObservable =
      this.activityService.getActivitiesByParentEntityType(
        PARENT_ENTITY_TYPE.PROJECT, // 5
        entityId, // ID de la subtarea (serviceOrder)
        0,
        100,
        'desc',
        'dateCreated',
      );

    activityObservable
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loadingActivities = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response) => {
          let activitiesData: Activity[] = [];

          if (Array.isArray(response)) {
            activitiesData = response;
          } else if (response.data?.rows) {
            activitiesData = response.data.rows;
          } else if (response.data) {
            activitiesData = Array.isArray(response.data) ? response.data : [];
          }

          // Actualizar el objeto user de cada actividad con los datos correctos de la lista de usuarios
          this.enrichActivitiesWithUserData(activitiesData);

          this.activities = activitiesData;

          this.groupActivitiesByDate();
          this.activitiesLoaded = true;

          // Forzar detección de cambios para asegurar que el template se actualice
          this.cdr.detectChanges();
        },
        error: (e) => {
          console.error('Error al cargar actividades:', e);
          this.activities = [];
          this.activitiesGroupedByDate = [];
        },
      });
  }

  // Enriquecer actividades con datos actualizados del usuario
  // IMPORTANTE: Siempre actualizamos desde la lista de usuarios porque el backend puede tener datos desactualizados
  private enrichActivitiesWithUserData(activities: Activity[]): void {
    const users = this.globalValuesService.users$.value;

    activities.forEach((activity) => {
      if (!activity.userId) return;

      const originalPartnerName = activity.user?.partner?.name;
      const originalUserId = activity.userId;
      const originalPartnerId = activity.user?.partnerId;

      // Buscar el usuario por userId (id del usuario)
      let user = users.find((u) => u.id === activity.userId);

      // Si no se encuentra, buscar por partnerId del activity-type.user si existe
      if (!user && activity.user?.partnerId) {
        const partnerId = activity.user.partnerId;
        user = users.find((u) => u.partner?.id === partnerId);
      }

      // Si aún no se encuentra, intentar buscar usando userId como si fuera partnerId
      // (porque en el drawer de actividad se guarda partner.id como userId)
      if (!user) {
        user = users.find((u) => u.partner?.id === activity.userId);
      }

      // Si se encontró el usuario, SIEMPRE actualizar el objeto user de la actividad
      // con los datos actualizados de la lista de usuarios
      if (user && user.partner) {
        const newPartnerName = user.partner.name;
        const newPartnerSurName = user.partner.surName || '';
        const fullNewName = `${newPartnerName} ${newPartnerSurName}`.trim();

        /* console.log(
          `Actualizando actividad userId: ${originalUserId}, partnerId backend: ${originalPartnerId}, nombre backend: "${originalPartnerName}", nombre actualizado: "${newPartnerName}"`
        );
 */
        // Forzar la actualización del objeto user completo creando un nuevo objeto
        // Esto asegura que Angular detecte el cambio
        activity.user = {
          id: user.id,
          email: user.email,
          roleId: user.roleId,
          partnerId: user.partner.id,
          partner: {
            id: user.partner.id,
            avatar: user.partner.avatar,
            name: user.partner.name,
            surName: user.partner.surName,
          },
        };

        // Verificar que la actualización se aplicó correctamente
        if (activity.user?.partner?.name !== newPartnerName) {
          console.error(
            `ERROR: No se actualizó correctamente. Esperado: "${newPartnerName}", Actual: "${activity.user?.partner?.name}"`,
          );
        }
      } else {
        console.warn(
          `No se encontró usuario para activity.userId: ${activity.userId}, activity.user?.partnerId: ${originalPartnerId}, nombre backend: "${originalPartnerName}"`,
        );
        // Log para debug: mostrar todos los usuarios disponibles
      }
    });
  }

  // Agrupar actividades por fecha
  private groupActivitiesByDate(): void {
    if (!Array.isArray(this.activities) || this.activities.length === 0) {
      this.activitiesGroupedByDate = [];
      return;
    }

    const grouped: { [key: string]: Activity[] } = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.activities.forEach((activity) => {
      // Para el divider: usar fecha de creación (createdOn)
      const dateStr = activity.createdOn;

      if (!dateStr) {
        const key = 'Sin fecha';
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(activity);
        return;
      }

      const activityDate = this.convertUTCToSpainDate(dateStr);
      if (!activityDate) {
        const key = 'Sin fecha';
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(activity);
        return;
      }

      activityDate.setHours(0, 0, 0, 0);
      const key = activityDate.toISOString().split('T')[0];

      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(activity);
    });

    // Convertir a array y ordenar por fecha descendente
    this.activitiesGroupedByDate = Object.keys(grouped)
      .sort((a, b) => {
        if (a === 'Sin fecha') return 1;
        if (b === 'Sin fecha') return -1;
        return new Date(b).getTime() - new Date(a).getTime();
      })
      .map((dateKey) => {
        let label = dateKey;
        if (dateKey !== 'Sin fecha') {
          const date = new Date(dateKey);
          const todayDate = new Date();
          todayDate.setHours(0, 0, 0, 0);

          if (date.getTime() === todayDate.getTime()) {
            label = 'HOY';
          } else {
            label = date
              .toLocaleDateString('es-ES', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
              })
              .toUpperCase();
          }
        }
        return {
          date: dateKey,
          label: label,
          activities: grouped[dateKey],
        };
      });
  }

  // Obtener icono según el tipo de actividad
  getActivityIcon(activity: Activity): string {
    // Primero intentar usar el icono del activityType si existe
    if (activity.activityType?.icon) {
      return activity.activityType.icon;
    }

    // Fallback: determinar icono por nombre del tipo
    const typeName = activity.activityType?.name?.toLowerCase() || '';

    if (
      typeName.includes('correo') ||
      typeName.includes('email') ||
      typeName.includes('mail')
    ) {
      return 'mail';
    }
    if (
      typeName.includes('llamada') ||
      typeName.includes('call') ||
      typeName.includes('teléfono')
    ) {
      return 'call';
    }
    if (
      typeName.includes('reunión') ||
      typeName.includes('meeting') ||
      typeName.includes('calendario')
    ) {
      return 'groups';
    }
    if (typeName.includes('tarea') || typeName.includes('task')) {
      return 'task_alt';
    }
    return 'event_note';
  }

  // Obtener color del icono según el tipo de actividad
  getActivityIconColor(activity: Activity): string {
    // Icono blanco cuando tiene fondo de color
    if (
      activity.hasExpired ||
      activity.state === 'Done' ||
      activity.state === 'Cancelled' ||
      activity.state === 'InProgress' ||
      activity.state === 'Planned'
    ) {
      return '#fff';
    }
    return activity.activityType?.color || '#666';
  }

  // Obtener clase del wrapper del icono según estado
  getActivityIconWrapperClass(activity: Activity): string {
    if (
      activity.hasExpired &&
      activity.state !== 'Done' &&
      activity.state !== 'Cancelled'
    ) {
      return 'icon-wrapper-expired';
    }
    switch (activity.state) {
      case 'Done':
        return 'icon-wrapper-completed';
      case 'Cancelled':
        return 'icon-wrapper-cancelled';
      case 'InProgress':
        return 'icon-wrapper-in-progress';
      default:
        return 'icon-wrapper-pending';
    }
  }

  // Obtener estado formateado
  getActivityStatusClass(state: string): string {
    switch (state) {
      case 'Done':
        return 'status-completed';
      case 'Cancelled':
        return 'status-cancelled';
      case 'InProgress':
        return 'status-in-progress';
      default:
        return 'status-pending';
    }
  }

  getActivityStatusLabel(state: string): string {
    switch (state) {
      case 'Done':
        return 'Hecho';
      case 'Cancelled':
        return 'Cancelada';
      case 'InProgress':
        return 'En progreso';
      case 'Planned':
        return 'Pendiente';
      default:
        return state;
    }
  }

  // Obtener iniciales del usuario desde partner
  getUserInitials(activity: Activity): string {
    // Prioridad 1: Usar directamente los datos que vienen del backend en activity-type.user?.partner
    if (activity.user?.partner) {
      const firstName = activity.user.partner.name || '';
      const lastName = activity.user.partner.surName || '';
      // Si solo hay firstName, usar las primeras 2 letras del nombre
      if (firstName && !lastName) {
        return firstName.substring(0, 2).toUpperCase();
      }
      const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
      if (initials && initials.length >= 2) return initials;
      // Si solo hay una letra, usar la primera del nombre
      if (firstName) return firstName.charAt(0).toUpperCase();
    }

    // Prioridad 2: Buscar en la lista actualizada de usuarios por partnerId
    // IMPORTANTE: El userId guardado en la actividad puede ser un partnerId cuando viene del drawer
    // Por eso buscamos PRIMERO por partnerId y luego por userId como fallback
    const users = this.globalValuesService.users$.value;
    let user = null;

    // Primero buscar por partnerId del activity-type.user (más confiable)
    if (activity.user?.partnerId) {
      const partnerId = activity.user.partnerId;
      user = users.find((u) => u.partner?.id === partnerId);
    }

    // Si no se encontró, buscar usando userId como si fuera partnerId
    // porque en el drawer de actividad se guarda partner.id como userId
    if (!user) {
      const userId = activity.userId || activity.user?.id;
      if (userId) {
        user = users.find((u) => u.partner?.id === userId);
      }
    }

    // Como último recurso, buscar por user.id (pero esto raramente coincidirá)
    if (!user) {
      const userId = activity.userId || activity.user?.id;
      if (userId) {
        user = users.find((u) => u.id === userId);
      }
    }

    if (user?.partner) {
      const firstName = user.partner.name || '';
      const lastName = user.partner.surName || '';
      if (firstName && !lastName) {
        return firstName.substring(0, 2).toUpperCase();
      }
      const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
      if (initials && initials.length >= 2) return initials;
      if (firstName) return firstName.charAt(0).toUpperCase();
    }

    return 'U';
  }

  // Obtener nombre completo del usuario desde partner
  getUserFullName(activity: Activity): string {
    // Prioridad 1: Usar directamente los datos que vienen del backend en activity-type.user?.partner
    if (activity.user?.partner) {
      const firstName = activity.user.partner.name || '';
      const lastName = activity.user.partner.surName || '';
      const fullName = `${firstName} ${lastName}`.trim();
      if (fullName) return fullName;
      // Si solo hay nombre o solo apellido
      if (firstName) return firstName;
      if (lastName) return lastName;
    }

    // Prioridad 2: Buscar en la lista actualizada de usuarios por partnerId
    // IMPORTANTE: El userId guardado en la actividad puede ser un partnerId cuando viene del drawer
    // Por eso buscamos PRIMERO por partnerId y luego por userId como fallback
    const users = this.globalValuesService.users$.value;
    let user = null;

    // Primero buscar por partnerId del activity-type.user (más confiable)
    if (activity.user?.partnerId) {
      const partnerId = activity.user.partnerId;
      user = users.find((u) => u.partner?.id === partnerId);
    }

    // Si no se encontró, buscar usando userId como si fuera partnerId
    // porque en el drawer de actividad se guarda partner.id como userId
    if (!user) {
      const userId = activity.userId || activity.user?.id;
      if (userId) {
        user = users.find((u) => u.partner?.id === userId);
      }
    }

    // Como último recurso, buscar por user.id (pero esto raramente coincidirá)
    if (!user) {
      const userId = activity.userId || activity.user?.id;
      if (userId) {
        user = users.find((u) => u.id === userId);
      }
    }

    if (user?.partner) {
      const firstName = user.partner.name || '';
      const lastName = user.partner.surName || '';
      const fullName = `${firstName} ${lastName}`.trim();
      if (fullName) return fullName;
      if (firstName) return firstName;
      if (lastName) return lastName;
    }

    return 'Usuario';
  }

  // Obtener iniciales desde un objeto de usuario directamente
  getUserInitialsFromUser(user: any): string {
    if (!user) return 'U';

    const firstName = user.name || '';
    const lastName = user.surName || '';

    // Si solo hay firstName, usar las primeras 2 letras del nombre
    if (firstName && !lastName) {
      return firstName.substring(0, 2).toUpperCase();
    }

    // Combinar iniciales
    const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    if (initials && initials.length >= 2) return initials;

    // Si solo hay una letra, usar la primera del nombre
    if (firstName) return firstName.charAt(0).toUpperCase();

    return 'U';
  }

  // Formatear hora de la actividad
  getActivityTime(activity: Activity): string {
    const dateStr = activity.dateCreated || activity.dateDeadLine;
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  // Formatear fecha de vencimiento
  getActivityDueDate(activity: Activity): string {
    if (!activity.dateDeadLine) return '';
    const date = new Date(activity.dateDeadLine);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  // Propiedades para el modal de completación
  completionModalActivity: Activity | null = null;
  completionNote: string = '';
  currentCompletionModalRef: NzModalRef | null = null;

  // Método para manejar el cambio en la nota de completación
  onCompletionNoteChange(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.completionNote = target?.value || '';
  }

  // Método para cerrar el modal de completación y abrir nueva actividad
  closeCompletionModal(): void {
    if (this.currentCompletionModalRef && this.completionModalActivity) {
      // Primero marcar como completada
      this.executeMarkAsCompleted(
        this.completionModalActivity,
        this.completionNote,
      );

      // Luego cerrar modal y abrir drawer
      this.currentCompletionModalRef.close();
      this.currentCompletionModalRef = null;
      this.completionModalActivity = null;

      // Abrir el drawer de crear nueva actividad
      this.openCreateActivityDrawer();
    }
  }

  // Método para cancelar el modal de completación (sin abrir drawer)
  cancelCompletionModal(): void {
    if (this.currentCompletionModalRef) {
      this.currentCompletionModalRef.close();
      this.currentCompletionModalRef = null;
      this.completionModalActivity = null;
    }
  }

  // Método para confirmar la completación de la actividad
  confirmCompleteActivity(): void {
    if (this.completionModalActivity) {
      this.executeMarkAsCompleted(
        this.completionModalActivity,
        this.completionNote,
      );
      // Cerrar modal sin abrir drawer
      if (this.currentCompletionModalRef) {
        this.currentCompletionModalRef.close();
        this.currentCompletionModalRef = null;
        this.completionModalActivity = null;
      }
    }
  }

  // Marcar actividad como completada
  markActivityAsCompleted(activity: Activity): void {
    if (!activity.id) return;

    this.completionModalActivity = activity;
    this.completionNote = '';

    const modalRef: NzModalRef = this.modalService.create({
      nzTitle: 'Marcar actividad como completada',
      nzContent: this.completionModalTmpl,
      nzWidth: 600,
      nzBodyStyle: { minHeight: '300px' },
      nzMaskClosable: false,
      nzCentered: true,
      nzFooter: null,
    });

    // Guardar referencia del modal para los métodos de los botones
    this.currentCompletionModalRef = modalRef;
  }

  private executeMarkAsCompleted(activity: Activity, note?: string): void {
    // Usar el ID de la subtarea (serviceOrder) en lugar del ID del proyecto
    const parentEntityType = PARENT_ENTITY_TYPE.PROJECT; // 5
    const parentEntityId =
      this.opportunity?.id ||
      this.opportunity?.originalId ||
      this.serviceOrder?.id ||
      0;

    this.activityService
      .markAsDone({
        id: activity.id!,
        parentEntityType: parentEntityType,
        parentEntityId: parentEntityId,
        doneNote: note,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toastConfig = {
            icon: 'check_circle',
            iconColor: '#6CDA75',
            content: 'Actividad marcada como completada.',
            showUndo: false,
          };
          this.showNotification('Actividad marcada como completada.');
          this.loadActivities();
        },
        error: (e) => {
          console.error('Error al marcar actividad:', e);
        },
      });
  }

  // Cancelar actividad
  cancelActivityAction(activity: Activity): void {
    if (!activity.id) return;

    this.modalService.confirm({
      nzTitle: '¿Cancelar actividad?',
      nzContent: `¿Estás seguro de que deseas cancelar esta actividad? Esta acción no se puede deshacer.`,
      nzOkText: 'Sí, cancelar',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzCancelText: 'No, volver',
      nzOnOk: () => {
        this.executeCancelActivity(activity);
      },
    });
  }

  private executeCancelActivity(activity: Activity): void {
    // Usar el ID de la subtarea (serviceOrder) en lugar del ID del proyecto
    const parentEntityType = PARENT_ENTITY_TYPE.PROJECT; // 5
    const parentEntityId =
      this.opportunity?.id ||
      this.opportunity?.originalId ||
      this.serviceOrder?.id ||
      0;

    this.activityService
      .cancelActivity({
        id: activity.id!,
        parentEntityType: parentEntityType,
        parentEntityId: parentEntityId,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toastConfig = {
            icon: 'check_circle',
            iconColor: '#6CDA75',
            content: 'Actividad cancelada.',
            showUndo: false,
          };
          this.showNotification('Actividad cancelada.');
          this.loadActivities();
        },
        error: (e) => {
          console.error('Error al cancelar actividad:', e);
        },
      });
  }

  // Create budget from opportunity
  createBudget(): void {
    // Calcular siguiente número secuencial para evitar nombres duplicados
    const baseName = 'Presupuesto';
    let maxNumber = 0;
    this.budgetList.forEach(b => {
      if (b.name?.startsWith(baseName)) {
        const match = b.name.match(/#(\d+)$/);
        if (match) {
          maxNumber = Math.max(maxNumber, parseInt(match[1], 10));
        } else {
          maxNumber = Math.max(maxNumber, 1);
        }
      }
    });
    const nextNumber = maxNumber + 1;

    const payload = {
      name: `${baseName} #${nextNumber}`,
      isActive: true,
      leadId: this.opportunity.id,
      teamId: this.opportunity.teamId,
      // CEC-565: sin respaldo, una compañia sin moneda dejaba el alta sin currencyId y el
      // backend, que ahora la exige, respondia 400.
      currencyId: resolveNewQuotationCurrencyId(
        [this.opportunity.company?.currencyId, this.opportunity?.currencyId],
        this.globalValuesService.currencies$.value,
      ),
      partnerId: this.opportunity.partnerId,
      expirationDate: new Date(
        new Date().setMonth(new Date().getMonth() + 1),
      ).toISOString(),
    };

    // Crear presupuesto usando el servicio
    this.opportunityService
      .createSaleOrder(payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          //this.creatingBudget = false;
        }),
      )
      .subscribe({
        next: (response: any) => {
          this.toastConfig = {
            icon: 'check_circle',
            iconColor: '#6CDA75',
            content: 'Presupuesto creado.',
            showUndo: false,
          };

          this.notRef = this.notificationService.create(
            'blank',
            '',
            this.notificationTmpl,
            { nzPlacement: 'bottomRight' },
          );

          // Usar el objeto completo de la respuesta en lugar de solo el ID
          if (response?.data) {
            // Agregar el presupuesto a la lista si no está
            const existingIndex = this.budgetList.findIndex(
              (b) => b.id === response.data.id,
            );
            if (existingIndex === -1) {
              this.budgetList.unshift(response.data);
            } else {
              // Actualizar si ya existe
              this.budgetList[existingIndex] = response.data;
            }

            // Abrir la vista con el objeto completo
            this.openBudgetView(response.data);
          }
        },
        error: (error) => {
          console.error('Error creating budget:', error);
        },
      });
  }

  // Create project from opportunity
  createProject(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const createProjectDrawer = this.drawerService.create({
          nzWidth: 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: CreateProjectDrawerComponent,
          nzData: {
            opportunityId: this.opportunity?.id || this.opportunity?.originalId,
            leadId: this.opportunity?.id || this.opportunity?.originalId, // Identificador de la oportunidad (Lead u Opportunity)
          },
        });

        createProjectDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          const contentComponent = createProjectDrawer.getContentComponent();
          if (contentComponent && contentComponent.createEvent) {
            contentComponent.createEvent.pipe(take(1)).subscribe(() => {
              // El proyecto se creó exitosamente
              createProjectDrawer.close();
            });
          }
        });
      });
  }

  // Create activity-type drawer
  openCreateActivityDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const createProjectDrawer = this.drawerService.create({
          nzWidth: 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: OportunitiesDetailsActivityDrawerComponent,
          nzData: {
            projectId:
              this.opportunity?.id ||
              this.opportunity?.originalId ||
              this.serviceOrder?.id,
            parentEntityType: PARENT_ENTITY_TYPE.PROJECT,
          },
        });

        createProjectDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          const contentComponent = createProjectDrawer.getContentComponent();

          // Escuchar cuando se crea una actividad y se cierra el drawer
          if (contentComponent && contentComponent.createEvent) {
            contentComponent.createEvent.pipe(take(1)).subscribe(() => {
              this.loadActivities();
              createProjectDrawer.close();
            });
          }

          // Escuchar cuando se crea una actividad pero el drawer permanece abierto (scheduleAndNext)
          if (contentComponent && contentComponent.activityScheduled) {
            contentComponent.activityScheduled.subscribe(() => {
              this.loadActivities();
            });
          }
        });
      });
  }

  // Create budget/quote drawer (Nuevo Presupuesto)
  openCreateBudgetDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const createBudgetDrawer = this.drawerService.create({
          nzWidth: isMobile ? '100%' : isMedium ? '80%' : 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: CreateProjectDrawerComponent,
          nzData: {
            opportunityId: this.opportunity?.id || this.opportunity?.originalId,
            leadId: this.opportunity?.id || this.opportunity?.originalId, // Identificador de la oportunidad (Lead u Opportunity)
            opportunity: this.opportunity,
            type: 'budget', // Para indicar que es un presupuesto
            existingBudgets: this.budgetList,
          },
        });

        createBudgetDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          const contentComponent = createBudgetDrawer.getContentComponent();
          if (contentComponent && contentComponent.createEvent) {
            contentComponent.createEvent.pipe(take(1)).subscribe(() => {
              // El presupuesto se creó exitosamente
              this.toastConfig = {
                icon: 'check_circle',
                iconColor: '#6CDA75',
                content: 'Presupuesto creado exitosamente.',
                showUndo: false,
              };
              this.showNotification();
              createBudgetDrawer.close();
            });
          }
        });
      });
  }

  // Create project drawer (Nuevo Proyecto)
  openCreateProjectDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const createProjectDrawer = this.drawerService.create({
          nzWidth: isMobile ? '100%' : isMedium ? '80%' : 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: CreateProjectDrawerComponent,
          nzData: {
            opportunityId: this.opportunity?.id || this.opportunity?.originalId,
            leadId: this.opportunity?.id || this.opportunity?.originalId, // Identificador de la oportunidad (Lead u Opportunity)
            opportunity: this.opportunity,
            type: 'project', // Para indicar que es un proyecto
          },
        });

        createProjectDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          const contentComponent = createProjectDrawer.getContentComponent();
          if (contentComponent && contentComponent.createEvent) {
            contentComponent.createEvent.pipe(take(1)).subscribe(() => {
              // El proyecto se creó exitosamente
              this.toastConfig = {
                icon: 'check_circle',
                iconColor: '#6CDA75',
                content: 'Proyecto creado exitosamente.',
                showUndo: false,
              };
              this.showNotification();
              createProjectDrawer.close();
            });
          }
        });
      });
  }

  // Edit activity-type drawer
  openEditActivityDrawer(activity: Activity): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const editActivityDrawer = this.drawerService.create({
          nzWidth: 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: OportunitiesDetailsActivityDrawerComponent,
          nzData: {
            projectId:
              this.opportunity?.id ||
              this.opportunity?.originalId ||
              this.serviceOrder?.id,
            parentEntityType: PARENT_ENTITY_TYPE.PROJECT,
            activity: activity, // Pasar la actividad a editar
          },
        });

        editActivityDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          const contentComponent = editActivityDrawer.getContentComponent();
          if (contentComponent && contentComponent.createEvent) {
            contentComponent.createEvent.pipe(take(1)).subscribe(() => {
              // La actividad se actualizó exitosamente, recargar lista
              this.loadActivities();
              editActivityDrawer.close();
            });
          }
        });
      });
  }

  // Create new opportunity
  // Alternar visibilidad del panel de actividades en móvil
  toggleActivitiesPanel(): void {
    this.showActivitiesPanel = !this.showActivitiesPanel;
  }

  createNewOpportunity(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const addOpportunityDrawer = this.drawerService.create({
          nzWidth: 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzMask: true,
          nzContent: OportunitiesAddDrawerComponent,
          nzData: {
            flowId: undefined,
            readonly: false,
          },
        });

        // Recargar oportunidades cuando el drawer se cierre
        addOpportunityDrawer.afterClose.subscribe((result: any) => {
          if (result) {
            // Si hay un resultado, significa que se creó exitosamente
            // Emitir evento para que el componente padre recargue las oportunidades
            this.createNewOpportunityEvent.emit();
          }
        });
      });
  }

  // Handle dropdown action from split button
  onSplitButtonDropdownAction(action: string): void {
    if (action === 'newOpportunity') {
      this.createNewOpportunity();
    } else if (action === 'newProject') {
      this.createProject();
    } else if (action === 'newBudget') {
      this.openBudgetDrawer();
    }
  }

  // Open budget drawer (alias para mantener compatibilidad)
  openBudgetDrawer(): void {
    this.createBudget();
  }

  // Convert lead to opportunity
  convertToOpportunity(): void {
    const leadId = this.opportunity?.id || this.opportunity?.originalId;
    if (!leadId) {
      console.warn('No se encontró el ID del lead');
      return;
    }

    // Abrir el drawer de conversión primero
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        const convertDrawer = this.drawerService.create({
          nzWidth: 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: ConvertLeadDrawerComponent,
          nzData: {
            leadId: leadId,
          },
        });

        // Escuchar el evento de conversión
        convertDrawer.afterOpen.pipe(take(1)).subscribe(() => {
          const contentComponent = convertDrawer.getContentComponent();
          if (contentComponent && contentComponent.convertEvent) {
            contentComponent.convertEvent
              .pipe(take(1))
              .subscribe((convertData) => {
                // Cerrar el drawer de conversión
                convertDrawer.close();

                // Primero, realizar la conversión (POST)
                this.loading = true;
                this.opportunityService
                  .convertLead(leadId, convertData.currencyId, convertData.expectedClosingDate)
                  .pipe(
                    takeUntilDestroyed(this.destroyRef),
                    finalize(() => {
                      this.loading = false;
                    }),
                  )
                  .subscribe({
                    next: (response) => {
                      if (response.success && response.data) {
                        // Si la conversión es exitosa, entonces actualizar la entidad (PATCH)

                        // Construir el payload completo con todas las propiedades
                        const opportunityName = this.getOpportunityName();

                        // Helper para obtener valor de ID (null si es 0 o no existe)
                        const getIdValue = (value: any): number | null => {
                          return value && value !== 0 ? value : null;
                        };

                        // Construir el payload de actualización
                        const patchPayload: any = {
                          id: leadId,
                          companyId: getIdValue(this.opportunity?.companyId),
                          name:
                            opportunityName ||
                            this.opportunity?.name ||
                            this.opportunity?.oportunidad ||
                            this.opportunity?.originalOpportunityName ||
                            '',
                          type: this.opportunity?.type || 'Lead',
                          opportunityType: convertData.opportunityType,
                          priority: this.opportunity?.priority || null,
                          expectedRevenue:
                            this.opportunity?.expectedRevenue?.parsedValue ??
                            (this.opportunity?.expectedRevenue?.source
                              ? parseFloat(
                                  this.opportunity.expectedRevenue.source,
                                )
                              : null) ??
                            this.opportunity?.expectedRevenue ??
                            0,
                          probability: this.opportunity?.probability || 0,
                          expectedClosingDate: this.opportunity
                            ?.expectedClosingDate
                            ? typeof this.opportunity.expectedClosingDate ===
                              'string'
                              ? this.opportunity.expectedClosingDate
                              : new Date(
                                  this.opportunity.expectedClosingDate,
                                ).toISOString()
                            : null,
                          source: this.opportunity?.source || null,
                          description: this.opportunity?.description || null,
                          email: this.opportunity?.email || null,
                          phone: this.opportunity?.phone || null,
                          mobile: this.opportunity?.mobile || null,
                          street: this.opportunity?.street || null,
                          street2: this.opportunity?.street2 || null,
                          city: this.opportunity?.city || null,
                          province: this.opportunity?.province || null,
                          zip: this.opportunity?.zip || null,
                          website: this.opportunity?.website || null,
                          clientCompany:
                            this.opportunity?.clientCompany || null,
                          jobTitle: this.opportunity?.jobTitle || null,
                          isActive:
                            this.opportunity?.isActive !== undefined
                              ? this.opportunity.isActive
                              : true,
                          dateConversion: this.opportunity?.dateConversion
                            ? typeof this.opportunity.dateConversion ===
                              'string'
                              ? this.opportunity.dateConversion
                              : new Date(
                                  this.opportunity.dateConversion,
                                ).toISOString()
                            : null,
                          dateWon: this.opportunity?.dateWon
                            ? typeof this.opportunity.dateWon === 'string'
                              ? this.opportunity.dateWon
                              : new Date(this.opportunity.dateWon).toISOString()
                            : null,
                          dateLost: this.opportunity?.dateLost
                            ? typeof this.opportunity.dateLost === 'string'
                              ? this.opportunity.dateLost
                              : new Date(
                                  this.opportunity.dateLost,
                                ).toISOString()
                            : null,
                          dateLastActivity: this.opportunity?.dateLastActivity
                            ? typeof this.opportunity.dateLastActivity ===
                              'string'
                              ? this.opportunity.dateLastActivity
                              : new Date(
                                  this.opportunity.dateLastActivity,
                                ).toISOString()
                            : null,
                          dateNextActivity: this.opportunity?.dateNextActivity
                            ? typeof this.opportunity.dateNextActivity ===
                              'string'
                              ? this.opportunity.dateNextActivity
                              : new Date(
                                  this.opportunity.dateNextActivity,
                                ).toISOString()
                            : null,
                          partnerId: getIdValue(this.opportunity?.partnerId),
                          userId: getIdValue(convertData.userId),
                          teamId: getIdValue(convertData.teamId),
                          stageId: getIdValue(this.opportunity?.stageId),
                          lostReasonId: getIdValue(
                            this.opportunity?.lostReasonId,
                          ),
                          countryId: getIdValue(this.opportunity?.countryId),
                          stateId: getIdValue(this.opportunity?.stateId),
                          chatId: getIdValue(this.opportunity?.chatId),
                          costCenterId: getIdValue(convertData.costCenterId),
                        };

                        // Agregar tagIds si existen
                        if (this.opportunity?.tags) {
                          let tagIds: number[] = [];
                          if (Array.isArray(this.opportunity.tags)) {
                            if (
                              this.opportunity.tags.length > 0 &&
                              typeof this.opportunity.tags[0] === 'number'
                            ) {
                              tagIds = this.opportunity.tags;
                            } else {
                              tagIds = this.opportunity.tags
                                .map((tag: any) => tag.id || tag)
                                .filter(Boolean);
                            }
                          }
                          if (tagIds.length > 0) {
                            patchPayload.tagIds = tagIds;
                          }
                        }

                        // Ahora actualizar la entidad con el PATCH
                        this.loading = true;
                        this.opportunityService
                          .patchOpportunity(patchPayload)
                          .pipe(
                            takeUntilDestroyed(this.destroyRef),
                            finalize(() => {
                              this.loading = false;
                            }),
                          )
                          .subscribe({
                            next: (rsp) => {
                              // Mapear la nueva oportunidad
                              const newOpportunity =
                                this.opportunitiesUtilsService.mapOpportunityData(
                                  rsp.data,
                                );

                              // ACTUALIZAR EL ESTADO SIN CERRAR EL DRAWER
                              this.opportunity = newOpportunity;
                              this.isLead = false;
                              this.viewMode = 'opportunity';

                              // Actualizar propiedades
                              this.updateCanCreateQuote();
                              this.updateComputedProperties();
                              this.updateStagesForTeam();
                              this.updateCurrentStageName();

                              // Cargar presupuestos ahora que es una oportunidad
                              this.loadBudgets();

                              // Actualizar la URL para reflejar el cambio
                              this.updateUrlFromState();

                              // Mostrar notificación
                              this.toastConfig = {
                                icon: 'check_circle',
                                iconColor: '#6CDA75',
                                content:
                                  'Lead convertido en oportunidad exitosamente.',
                                showUndo: false,
                              };
                              this.notRef = this.notificationService.create(
                                'blank',
                                '',
                                this.notificationTmpl,
                                { nzPlacement: 'bottomRight' },
                              );

                              // Emitir eventos para actualizar la tabla (eliminar lead, agregar oportunidad)
                              this.deleteEvent.emit(leadId);
                              this.updateEvent.emit(newOpportunity);

                              // Forzar detección de cambios
                              this.cdr.detectChanges();
                            },
                            error: (error) => {
                              this.toastConfig = {
                                icon: 'dangerous',
                                iconColor: '#CB2A2F',
                                content:
                                  error.error?.message ||
                                  'Error al actualizar el lead convertido.',
                                showUndo: false,
                              };
                              this.notRef = this.notificationService.create(
                                'blank',
                                '',
                                this.notificationTmpl,
                                { nzPlacement: 'bottomRight' },
                              );
                            },
                          });
                      } else {
                        this.toastConfig = {
                          icon: 'dangerous',
                          iconColor: '#CB2A2F',
                          content:
                            response.message || 'Error al convertir el lead.',
                          showUndo: false,
                        };
                        this.notRef = this.notificationService.create(
                          'blank',
                          '',
                          this.notificationTmpl,
                          { nzPlacement: 'bottomRight' },
                        );
                      }
                    },
                    error: (error) => {
                      this.toastConfig = {
                        icon: 'dangerous',
                        iconColor: '#CB2A2F',
                        content:
                          error.error?.message || 'Error al convertir el lead.',
                        showUndo: false,
                      };
                      this.notRef = this.notificationService.create(
                        'blank',
                        '',
                        this.notificationTmpl,
                        { nzPlacement: 'bottomRight' },
                      );
                    },
                  });
              });
          }
        });
      });
  }
  private showNotification(message?: string): void {
    // Solo configurar toastConfig si se proporciona un mensaje o si no está configurado
    if (message || !this.toastConfig.content) {
      this.toastConfig = {
        icon: 'check_circle',
        iconColor: '#6CDA75',
        content: message || 'Actividad programada exitosamente.',
        showUndo: false,
      };
    }
    this.notRef = this.notificationService.create(
      'blank',
      '',
      this.notificationTmpl,
      { nzPlacement: 'bottomRight' },
    );
  }

  private showErrorNotification(message: string): void {
    this.toastConfig = {
      icon: 'dangerous',
      iconColor: '#CB2A2F',
      content: message,
      showUndo: false,
    };
    this.notRef = this.notificationService.create(
      'blank',
      '',
      this.notificationTmpl,
      { nzPlacement: 'bottomRight' },
    );
  }
  // Request documents for lead
  requestDocuments(): void {
    // TODO: Implementar lógica para solicitar documentos necesarios
  }

  /**
   * Convierte una fecha UTC a la zona horaria española (Europe/Madrid)
   * @param utcDateString Fecha en formato ISO string (UTC)
   * @returns Date object en zona horaria española o null si es inválida
   */
  private convertUTCToSpainDate(utcDateString: string): Date | null {
    try {
      // Crear fecha UTC
      const utcDate = new Date(utcDateString);
      if (Number.isNaN(utcDate.getTime())) {
        return null;
      }

      // Crear una fecha en zona horaria española usando el método nativo
      // Esto automáticamente maneja el horario de verano (DST)
      const spainDate = new Date(
        utcDate.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }),
      );

      return spainDate;
    } catch (error) {
      console.error('Error convirtiendo fecha UTC a España:', error);
      return null;
    }
  }

  ngOnDestroy(): void {
    this.drawerEscapeBlocker.unblock();
  }
}
